// import React, { useEffect, useState } from "react";
// import { ChevronRight, Upload, Download, Eye, X, ChevronLeft } from "lucide-react";
// import "../../styles/upload.css";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useRef } from "react";
// import Firstphoto from "../../assets/uploadpage1.png";
// import Scoundphoto from "../../assets/uploadpage2.png";
// import { IoClose } from "react-icons/io5";
// import OMRPDF from "../../assets/omrimages/OMRPDF.png";
// import OMR_20 from "../../assets/omrimages/20-OMR-EMPTY-Q.png";
// import OMR_50 from "../../assets/omrimages/50-OMR-EMPTY-Q.png";
// import OMR_100 from "../../assets/omrimages/100-OMR-EMPTY-Q.png";
// import OMR_150 from "../../assets/omrimages/150-OMR-EMPTY-Q.png";
// import OMR_200 from "../../assets/omrimages/200-OMR-EMPTY.png";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   masterdata_create,
//   masterdata_list,
//   students_profile,
//   institution_dashboard,
//   batch_create,
//   update_profile,
//   masterdata_update,
//   user_exams_add,
// } from "../../util/Apiendpoits";
// import {
//   deleteWithTokenAPI,
//   deleteWithTokenAPIpayload,
//   getWithoutTokenAPI,
//   getWithTokenAPI,
//   ImageUpload,
//   postWithoutTokenAPI,
//   postWithTokenAPI,
//   putWithTokenAPI,
// } from "../../util/Api";
// import { FiBook, FiX } from "react-icons/fi";
// import Select from "react-select";
// import { SafeToast } from "../Toast/ShowToast";
// import SelectDropdown from "../ReusableComponent/SelectDropdown";
// import { setProfileData } from "../../store/profileSlice";

// const UploadPage = () => {
//   const location = useLocation();
//   const [tab, setTab] = useState(() => {
//     // if (location.state?.activeTab) {
//     //     return location.state.activeTab;
//     // }
//     const saved = localStorage.getItem("uploadFormData");
//     return saved ? "headline" : "headline";
//   });
//   const [totalQuestions, setTotalQuestions] = useState(() => {
//     const saved = localStorage.getItem("totalQuestions");
//     return saved ? parseInt(saved) : 0;
//   });

//   const [answers, setAnswers] = useState(() => {
//     const saved = localStorage.getItem("omrAnswers");
//     return saved ? JSON.parse(saved) : {};
//   });

//   const navigate = useNavigate();
//   const profile = useSelector((state) => state.profile);
//   const { token, roleType, userId } = useSelector((state) => state.auth);
//   const [examOptions, setExamOptions] = useState([]);
//   const [allexamOptions, setAllExamOptions] = useState([]);

//   const [allSubexamOptions, setSubAllExamOptions] = useState([]);
//   const [subExamOptions, setSubExamOptions] = useState([]);
//   const [Institutionprofile, setInstitutionprofile] = useState(null);

//   const [openDialog, setOpenDialog] = useState(false);
//   const [showAddInput, setShowAddInput] = useState(false);
//   const [newExamValue, setNewExamValue] = useState("");
//   const dispatch = useDispatch();
//   const [examName, setExamName] = useState("");
//   const isExam = examName?.toLowerCase().trim() === "exam";
//   const [errors, setErrors] = useState({});
//   const [formData, setFormData] = useState(() => {
//     const savedFormData = localStorage.getItem("uploadFormData");
//     if (savedFormData) {
//       return JSON.parse(savedFormData);
//     }
//     return {
//       headlineTagline: "",
//       bannerTagline: "",
//       testFees: "",
//       testBatchName: "",
//       subTopic: "",
//       syllabus: "",
//       schedulePdf: "",
//       testNo: "1",
//       questionPdf: "",
//       answerPdf: "",
//       videoLink: "",
//       omrsheet: "",
//       examduration: ""
//     };
//   });

//   console.log(formData, 'formData')
//   const getParsedItem = (key) => {
//     try {
//       const item = localStorage.getItem(key);
//       return item ? JSON.parse(item) : null;
//     } catch (err) {
//       console.warn(`Invalid JSON in localStorage for ${key}`);
//       localStorage.removeItem(key); // cleanup bad data
//       return null;
//     }
//   };

//   const [activeExam, setActiveExam] = useState(() =>
//     getParsedItem("activeExam"),
//   );

//   console.log(activeExam, 'activeExamactiveExamactiveExam')
//   const [activeSubExam, setActiveSubExam] = useState(() =>
//     getParsedItem("activeSubExam"),
//   );
//   console.log(activeSubExam, 'activeSubExamactiveSubExamactiveSubExam')


//   useEffect(() => { }, [profile]);
//   useEffect(() => {
//     if (activeExam !== null) {
//       localStorage.setItem("activeExam", JSON.stringify(activeExam));
//     }
//   }, [activeExam]);

//   useEffect(() => {
//     if (activeSubExam !== null) {
//       localStorage.setItem("activeSubExam", JSON.stringify(activeSubExam));
//     }
//   }, [activeSubExam]);

//   // Dashboard stats
//   const [dashboardStats, setDashboardStats] = useState({
//     totalStudents: 0,
//     totalBatches: 0,
//   });

//   const [loading, setLoading] = useState(false);
//   const tabsRef = useRef(null);
//   const ExamtabsRef = useRef(null);

//   const fetchExamOptions = async () => {
//     try {
//       const response = await getWithoutTokenAPI(masterdata_list);

//       if (response.statusCode === 200) {
//         const options = response.data
//           .filter(
//             (item) => item.type === "examType" && item.status === "active",
//           )
//           .map((item) => ({
//             value: item.code,
//             label: item.value,
//             id: item._id,
//           }));
//         setAllExamOptions(options);

//         const Suboptions = response.data
//           .filter(
//             (item) => item.type === "subexamType" && item.status === "active",
//           )
//           .map((item) => ({
//             value: item.code,
//             label: item.value,
//             id: item._id,
//           }));
//         setSubAllExamOptions(Suboptions);
//       }
//     } catch (error) {
//       console.error("Error fetching exam options:", error);
//     }
//   };

//   useEffect(() => {
//     fetchExamOptions();
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("uploadFormData", JSON.stringify(formData));
//   }, [formData]);

//   // Save total questions to localStorage
//   useEffect(() => {
//     localStorage.setItem("totalQuestions", totalQuestions);
//   }, [totalQuestions]);

//   // Save answers to localStorage
//   useEffect(() => {
//     localStorage.setItem("omrAnswers", JSON.stringify(answers));
//   }, [answers]);

//   // Fetch institution profile
//   useEffect(() => {
//     if (roleType !== "institution_admin") return;
//     const fetchProfile = async () => {
//       try {
//         const updateRes = await getWithTokenAPI(
//           token,
//           `${students_profile}${userId}`,
//         );

//         if (updateRes?.statusCode === 200) {
//           setInstitutionprofile(updateRes.data);
//         }
//       } catch (error) {
//         console.log("Failed to load institution profile");
//         SafeToast.error("Failed to load profile");
//       }
//     };

//     fetchProfile();
//   }, [roleType, token, userId]);

//   const fetchUserExams = async () => {
//     try {
//       const response = await getWithTokenAPI(token, `/user/${userId}/exams`);

//       if (response?.statusCode === 200) {
//         const examOpts = response.data.exams.map((exam) => ({
//           value: exam._id,
//           label: exam.value,
//           code: exam.code,
//           id: exam._id,
//         }));
//         setExamOptions(examOpts);

//         const subExamOpts = response.data.subexams.map((subexam) => ({
//           value: subexam._id,
//           label: subexam.value,
//           parentCode: subexam.code,
//           id: subexam._id,
//         }));
//         setSubExamOptions(subExamOpts);
//       }
//     } catch (error) {
//       console.error("Error fetching user exams:", error);
//       SafeToast.error("Failed to load exams");
//     }
//   };
//   useEffect(() => {
//     if (!userId) return;
//     fetchUserExams();
//   }, [userId, token]);

//   // Fetch dashboard statistics
//   const fetchDashboardStats = async () => {
//     try {
//       const response = await getWithTokenAPI(
//         token,
//         `${institution_dashboard}${userId}`,
//       );

//       if (response?.success) {
//         setDashboardStats({
//           totalStudents: response.data?.totalStudents || 0,
//           totalBatches: response.data?.totalBatches || 0,
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching dashboard stats:", error);
//       SafeToast.error("Failed to load dashboard statistics");
//     }
//   };
//   useEffect(() => {
//     if (roleType !== "institution_admin" || !userId) return;

//     fetchDashboardStats();
//   }, [roleType, token, userId]);

//   const handleAddExam = async () => {
//     if (!newExamValue) {
//       SafeToast.success("Exams Updated successfully!");
//       setShowAddInput(false);
//       setOpenDialog(false);
//       return null;
//     }
//     const newExam = {
//       code:
//         examName === "exam" ? allSubexamOptions.length + 1 : activeExam.code,
//       value: newExamValue,
//       type: examName === "exam" ? "examType" : "subexamType",
//       status: "active",
//     };

//     try {
//       const response = await postWithoutTokenAPI(masterdata_create, newExam);
//       if (response.statusCode === 200 || response.statusCode === 201) {
//         const option = {
//           value: response.data?._id || newExam.code,
//           label: newExam.value,
//           code: newExam.code,
//         };
//         fetchExamOptions();
//         if (examName == "exam") {
//           setAllExamOptions((prev) => [...prev, option]);
//         } else {
//           setSubExamOptions((prev) => {
//             const relatedSubs = prev.filter(
//               (sub) => sub.parentCode === activeExam.code,
//             );
//             const exists = relatedSubs.some(
//               (sub) => sub.value === option.value,
//             );

//             if (exists) {
//               return prev.filter((sub) => sub.value !== option.value);
//             } else {
//               const newOption = {
//                 ...option,
//                 parentCode: activeExam.code,
//               };

//               return [...prev, newOption];
//             }
//           });
//         }

//         setNewExamValue("");
//         setShowAddInput(false);
//         SafeToast.success("New exam added successfully!");
//       }
//     } catch (error) {
//       console.error("Error creating new exam:", error);
//       SafeToast.error("Failed to add new exam");
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   };

//   const uploadFile = async (type, file) => {
//     // const MAX_SIZE = 50 * 1024 * 1024; 

//     // if (file.size > MAX_SIZE) {
//     //   SafeToast.error("Maximum allowed PDF size is 45 MB");
//     //   return null;
//     // }
//     const formData = new FormData();
//     formData.append("files", file);

//     try {
//       const response = await ImageUpload(
//         `/upload_image?userId=${userId}&type=${roleType}`,
//         formData,
//         true,
//       );
//       if (response.statusCode === 413) {
//         SafeToast.error("Maximum allowed PDF size is 45 MB");
//       }
//       if (response.statusCode === 200) {
//         return response?.data?.[0]?.fileUrl || null;
//       }

//     }
//     catch (error) {
//       SafeToast.error("Maximum allowed PDF size is 45 MB");
//       return null;
//     }
//   };

//   const handleFileUpload = async (fileType, file) => {
//     const fileUrl = await uploadFile(fileType, file);

//     if (!fileUrl) return;

//     setFormData((prev) => ({
//       ...prev,
//       [fileType]: {
//         name: file.name,
//         url: fileUrl,
//       },
//     }));

//     setErrors((prev) => {
//       const updatedErrors = { ...prev };
//       delete updatedErrors[fileType];
//       return updatedErrors;
//     });

//     SafeToast.success(
//       `${fileType.replace(/([A-Z])/g, " $1")} uploaded successfully`,
//     );
//   };

//   const handleExamClick = (exam) => {
//     setActiveExam(exam);

//     const related = subExamOptions.filter(
//       (sub) => sub.parentCode === exam.code,
//     );

//     setActiveSubExam((prev) =>
//       related.some((s) => s.id === prev?.id) ? prev : related[0] || null,
//     );
//   };

//   const handleSubExamClick = (subExam) => {
//     setActiveSubExam(subExam);
//   };

//   if (!activeExam?.value) { SafeToast.error("Please select Exam"); return; }
//   if (!activeSubExam?.value) { SafeToast.error("Please select Sub Exam"); return; }

//   const handlePublish = async () => {
//     // Validate required fields
//     if (!activeExam || !activeExam.value) {
//       SafeToast.error("Please select Exam");
//       return;
//     }

//     if (!activeSubExam || !activeSubExam.value) {
//       SafeToast.error("Please select Sub Exam");
//       return;
//     }
//     if (!formData.headlineTagline.trim()) {
//       SafeToast.error("Please enter Headline Tagline");
//       return;
//     }

//     if (!formData.testBatchName.trim()) {
//       SafeToast.error("Please enter Test Batch Name");
//       return;
//     }

//     if (!formData.questionPdf) {
//       SafeToast.error("Please upload Question PDF");
//       return;
//     }

//     if (!activeExam || !activeSubExam) {
//       SafeToast.error("Please select both exam and sub-exam");
//       return;
//     }

//     if (!Institutionprofile?._id) {
//     const testList = Array.isArray(batchList) ? batchList : [formData];
//     let successCount = 0;

//     setLoading(true);
//         setFormData({
//           headlineTagline: "",
//           bannerTagline: "",
//           testFees: "",
//           testBatchName: "",
//           subTopic: "",
//           syllabus: "",
//           schedulePdf: "",
//           testNo: "1",
//           questionPdf: "",
//           answerPdf: "",
//           videoLink: "",
//           omrsheet: "",
//           examduration: ""
//         });
//         setAnswers({});
//         setTotalQuestions(0);
//         setTab("headline");

//         // Clear localStorage
//         localStorage.removeItem("uploadFormData");
//         localStorage.removeItem("omrAnswers");
//         localStorage.removeItem("totalQuestions");

//         // Refresh dashboard stats
//         const statsResponse = await getWithTokenAPI(
//           token,
//           `${institution_dashboard}${userId}`,
//         );
//         if (statsResponse?.statusCode === 200) {
//           setDashboardStats({
//             totalStudents: statsResponse.data?.totalStudents || 0,
//             totalBatches: statsResponse.data?.totalBatches || 0,
//           });
//         }
//       } else {
//         SafeToast.error(response?.message || "Failed to create batch");
//       }
//     } catch (error) {
//       console.error("Error creating batch:", error);
//       SafeToast.error("An error occurred while creating the batch");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const ExamscrollLeft = () => {
//     if (ExamtabsRef.current) {
//       ExamtabsRef.current.scrollBy({ left: -200, behavior: "smooth" });
//     }
//   };

//   const ExamscrollRight = () => {
//     if (ExamtabsRef.current) {
//       ExamtabsRef.current.scrollBy({ left: 200, behavior: "smooth" });
//     }
//   };

//   const scrollLeft = () => {
//     if (tabsRef.current) {
//       tabsRef.current.scrollBy({ left: -200, behavior: "smooth" });
//     }
//   };

//   const scrollRight = () => {
//     if (tabsRef.current) {
//       tabsRef.current.scrollBy({ left: 200, behavior: "smooth" });
//     }
//   };

//   const handleNavigateToOMR = () => {
//     localStorage.setItem("uploadFormData", JSON.stringify(formData));
//     localStorage.setItem("omrAnswers", JSON.stringify(answers));
//     localStorage.setItem("totalQuestions", totalQuestions);
//     navigate("/omr");
//   };

//   const isExamChecked = (exam) => {
//     if (isExam) {
//       return examOptions.some((ex) => ex.code === exam.value);
//     } else {
//       return subExamOptions.some(
//         (sub) => (sub.id || sub.value) === (exam.id || exam.value),
//       );
//     }
//   };


//   const validateStep = (step) => {
//     let newErrors = {};

//     if (step === "headline") {
//       if (!formData.headlineTagline?.trim()) {
//         newErrors.headlineTagline = "Heading Tagline is required";
//       }
//       if (!formData.bannerTagline?.trim()) {
//         newErrors.bannerTagline = "Banner Tagline is required";
//       }
//     }

//     if (step === "batch") {
//       if (!formData.testBatchName?.trim()) {
//         newErrors.testBatchName = "Batch Name is required";
//       }
//       if (!formData.subTopic?.trim()) {
//         newErrors.subTopic = "Sub Topic is required";
//       }
//     }

//     if (step === "pricing") {
//       if (!formData.testFees) {
//         newErrors.testFees = "Test Fees is required";
//       }
//       if (!formData.examduration?.trim()) {
//         newErrors.examduration = "Exam Duration is required";
//       }
//     }

//     if (step === "syllabus") {
//       if (!formData.syllabus?.trim()) {
//         newErrors.syllabus = "Syllabus is required";
//       }
//       if (!formData.schedulePdf) {
//         newErrors.schedulePdf = "Schedule PDF is required";
//       }
//     }

//     setErrors((prev) => ({ ...prev, ...newErrors }));
//     return Object.keys(newErrors).length === 0;
//   };

//   const canNavigateTo = (targetTab) => {
//     const steps = ["headline", "batch", "pricing", "syllabus", "questions", "omr"];
//     const currentIdx = steps.indexOf(tab);
//     const targetIdx = steps.indexOf(targetTab);

//     if (targetIdx <= currentIdx) {
//       return true;
//     }

//     for (let i = currentIdx; i < targetIdx; i++) {
//       if (!validateStep(steps[i])) {
//         SafeToast.error(`Please fill all required fields in the current step`);
//         return false;
//       }
//     }
//     return true;
//   };

//   const validateFields = () => {
//     let newErrors = {};

//     if (!formData.headlineTagline?.trim()) {
//       newErrors.headlineTagline = "Heading Tagline is required";
//     }

//     if (!formData.bannerTagline?.trim()) {
//       newErrors.bannerTagline = "Banner Tagline is required";
//     }

//     if (!formData.testFees) {
//       newErrors.testFees = "Test Fees is required";
//     }

//     if (!formData.testBatchName?.trim()) {
//       newErrors.testBatchName = "Batch Name is required";
//     }

//     if (!formData.examduration?.trim()) {
//       newErrors.examduration = "Exam Duration is required";
//     }

//     if (!formData.schedulePdf) {
//       newErrors.schedulePdf = "Schedule PDF is required";
//     }

//     if (!formData.subTopic?.trim()) {
//       newErrors.subTopic = "Sub Topic is required";
//     }

//     if (!formData.syllabus?.trim()) {
//       newErrors.syllabus = "Syllabus is required";
//     }
//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const updateMasterData = async (exam, payload) => {
//     try {
//       const res = await putWithTokenAPI(
//         token,
//         `${masterdata_update}${exam.id}`,
//         payload,
//       );
//       if (res.statusCode === 200) {
//         setSubExamOptions((prev) =>
//           prev.map((item) =>
//             item.value === exam.value ? { ...item, parentCode: "-0" } : item,
//           ),
//         );
//       }
//     } catch (error) {
//       console.error("Masterdata update failed", error);
//       throw error;
//     }
//   };

//   const filteredSubExams = activeExam
//     ? allSubexamOptions.filter((sub) => sub.value === activeExam.code)
//     : [];
//   console.log(filteredSubExams, "FILTEREDSUBEXAMS");

//   const deleteUserExam = async ({ exams = [], subexams = [] }) => {
//     if (!token || !userId) {
//       console.warn("Missing token or userId");
//       return;
//     }

//     if (!exams.length && !subexams.length) {
//       console.warn("Nothing to delete");
//       return;
//     }

//     try {
//       const res = await deleteWithTokenAPIpayload(
//         token,
//         `/user/${userId}/exams-remove`,
//         {
//           exams,
//           subexams,
//         },
//       );

//       if (res?.statusCode === 200) {
//         SafeToast.success("Removed successfully");
//       } else {
//         SafeToast.error(res?.message || "Remove failed");
//       }
//     } catch (error) {
//       console.error("Delete exam error:", error);
//       SafeToast.error("Delete failed");
//     }
//   };
//   const getExamId = (exam) => exam?.id || exam?.value || null;


//   const handleAddExamClick = async (exam) => {
//     if (!exam) return;

//     const examId = getExamId(exam);
//     if (!examId) {
//       console.warn("Invalid exam object", exam);
//       return;
//     }

//     const examset = {
//       id: examId,
//       label: exam.label,
//       value: examId,
//     };

//     if (isExam) {
//       const exists = examOptions.some((ex) => ex.label === exam.label);

//       if (exists) {
//         // ✅ SAFE DELETE
//         await deleteUserExam({
//           exams: [examId],
//           subexams: [],
//         });

//         setExamOptions((prev) => prev.filter((ex) => ex.label !== exam.label));
//       } else {
//         setExamOptions((prev) => [...prev, examset]);
//         await handleSaveExam(examset);
//       }
//     } else {
//       const exists = subExamOptions.some(
//         (ex) => (ex.id || ex.value) === examId,
//       );

//       if (exists) {
//         // ✅ SAFE DELETE
//         await deleteUserExam({
//           exams: [],
//           subexams: [examId],
//         });

//         setSubExamOptions((prev) =>
//           prev.filter((ex) => (ex.id || ex.value) !== examId),
//         );
//       } else {
//         if (!activeExam?.code) {
//           SafeToast.error("Select an exam first");
//           return;
//         }
//         setSubExamOptions((prev) => [
//           ...prev,
//           {
//             ...exam,
//             parentCode: activeExam.code,
//           },
//         ]);
//         await handleSaveExam(examset);
//       }
//     }
//   };

//   const handleSaveExam = async (exam) => {
//     try {
//       const payload = {
//         [isExam ? "exams" : "subexams"]: [exam.id],
//       };
//       const res = await putWithTokenAPI(
//         token,
//         `${user_exams_add}/${userId}/exams-add`,
//         payload,
//       );

//       if (res?.statusCode === 200) {
//         SafeToast.success("Profile updated successfully");

//         dispatch(
//           setProfileData({
//             name:
//               roleType === "superadmin"
//                 ? res.data.name
//                 : res.data.nameofInstitution,
//             phone: res.data.phoneNumber,
//             role: res.data.roleType,
//             price: res.data.adminPrice,
//             profileImage: res.data.profile_img,
//             logo: res.data.logo,
//           }),
//         );
//         fetchUserExams();
//       } else {
//         SafeToast.error(res?.message || "Update failed");
//       }
//     } catch (error) {
//       console.error("Update error:", error);
//       SafeToast.error("Something went wrong");
//     }
//   };

//   const handleOpenDialog = (name) => {
//     console.log(name, "handleOpenDialog");
//     setExamName(name);
//     setOpenDialog(true);
//   };


//   const [focusedField, setFocusedField] = useState("");
//   const handleRemovePdf = (field) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: null
//     }));
//   };

//   const [omrModalOpen, setOmrModalOpen] = useState(false);

//   const handleSelectOMR = async (templateName, templateSrc) => {
//     setLoading(true);
//     try {
//       const response = await fetch(templateSrc);
//       const blob = await response.blob();
//       const file = new File([blob], `${templateName.toLowerCase().replace(/ /g, "_")}.png`, { type: "image/png" });
//       const fileUrl = await uploadFile("omrsheet", file);
//       if (fileUrl) {
//         setFormData((prev) => ({
//           ...prev,
//           omrsheet: {
//             name: `${templateName}.png`,
//             url: fileUrl,
//             localSrc: templateSrc,
//           },
//         }));
//         SafeToast.success(`${templateName} template selected and uploaded!`);
//       }
//     } catch (error) {
//       console.error("Error uploading OMR template:", error);
//       SafeToast.error("Failed to upload OMR template");
//     } finally {
//       setLoading(false);
//       setOmrModalOpen(false);
//     }
//   };

//   const getLocalOMRTemplate = (name) => {
//     if (!name) return null;
//     const cleanName = name.toLowerCase();
//     if (cleanName.includes("20 ")) return OMR_20;
//     if (cleanName.includes("50 ")) return OMR_50;
//     if (cleanName.includes("100 ")) return OMR_100;
//     if (cleanName.includes("150 ")) return OMR_150;
//     if (cleanName.includes("200 ")) return OMR_200;
//     return null;
//   };

//   const handleOMRDownload = async () => {
//     if (formData.omrsheet) {
//       // First try resolving to the local asset to bypass CORS completely
//       const localAsset = getLocalOMRTemplate(formData.omrsheet.name) || formData.omrsheet.localSrc;
//       const downloadUrl = localAsset || formData.omrsheet.url;

//       if (!downloadUrl) return;

//       try {
//         const response = await fetch(downloadUrl);
//         const blob = await response.blob();
//         const blobUrl = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = blobUrl;
//         link.download = formData.omrsheet.name || "OMRSheet.png";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(blobUrl);
//       } catch (error) {
//         console.error("OMR download failed:", error);
//         // Direct browser download trigger fallback
//         const link = document.createElement("a");
//         link.href = downloadUrl;
//         link.download = formData.omrsheet.name || "OMRSheet.png";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       }
//     }
//   };

//   const handleDownload = () => {
//     const link = document.createElement("a");
//     link.href = OMRPDF;
//     link.download = "OMRPDF.png";
//     link.click();
//   };

//   return (
//     <div className="upload-page">
//       <div className="stats-row">
//         <div
//           className="stat-card-upload student"
//           style={{ backgroundImage: `url(${Firstphoto})` }}
//         >
//           <span className="stat-title">Total Students</span>
//           <h2>{dashboardStats.totalStudents.toLocaleString()}</h2>
//         </div>
//         <div
//           className="stat-card-upload batch"
//           style={{ backgroundImage: `url(${Scoundphoto})`, cursor: "pointer" }}
//           onClick={() => navigate("/batches")}
//         >
//           <span className="stat-title">Total Batches</span>
//           <h2>{dashboardStats.totalBatches.toLocaleString()}</h2>
//         </div>
//       </div>

//       <div className="exam-box">
//         <div className="exam-header">
//           <h4>Exams</h4>
//           <div className="nav-arrows">
//             <div className="add-btn-wrapper">
//               <button
//                 className="add-btn"
//                 onClick={() => handleOpenDialog("exam")}
//               >
//                 <span className="plus">+</span>
//                 <span className="text">Add</span>
//               </button>
//             </div>
//             <button className="nav-btn" onClick={ExamscrollLeft}>
//               <ChevronLeft size={18} />
//             </button>
//             <button className="nav-btn" onClick={ExamscrollRight}>
//               <ChevronRight size={18} />
//             </button>
//           </div>
//         </div>

//         <div className="exam-tabs" ref={ExamtabsRef}>
//           {examOptions.length > 0 ? (
//             examOptions.map((exam) => (
//               <button
//                 key={exam.id || exam.value}
//                 className={activeExam?.value === exam.value ? "active" : ""}
//                 onClick={() => handleExamClick(exam)}
//               >
//                 {exam.label}
//               </button>
//             ))
//           ) : (
//             <div className="no-data-upload">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="no-data-upload-icon"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
//                 />
//               </svg>
//               <span>No exams found</span>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="exam-box">
//         <div className="exam-header">
//           <h4> Sub Exams</h4>
//           <div className="nav-arrows">
//             <div className="add-btn-wrapper">
//               <button
//                 className="add-btn"
//                 onClick={() => handleOpenDialog("subexam")}
//               >
//                 <span className="plus">+</span>
//                 <span className="text">Add</span>
//               </button>
//             </div>
//             <button className="nav-btn" onClick={scrollLeft}>
//               <ChevronLeft size={18} />
//             </button>
//             <button className="nav-btn" onClick={scrollRight}>
//               <ChevronRight size={18} />
//             </button>
//           </div>
//         </div>

//         <div className="exam-tabs" ref={tabsRef}>
//           {subExamOptions.filter(
//             (subExam) => subExam.parentCode === activeExam?.code,
//           ).length > 0 ? (
//             subExamOptions
//               .filter((subExam) => subExam.parentCode === activeExam?.code)
//               .map((subExam) => (
//                 <button
//                   key={subExam.id || subExam.value}
//                   className={
//                     activeSubExam?.id === subExam.id ? "active" : ""
//                   }
//                   onClick={() => handleSubExamClick(subExam)}
//                 >
//                   {subExam.label}
//                 </button>
//               ))
//           ) : (
//             <div className="no-data-upload">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="no-data-upload-icon"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
//                 />
//               </svg>
//               <span>No data found</span>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="main-card">
//         <div className="card-tabs" style={{ display: "flex", flexWrap: "wrap", gap: "8px", borderBottom: "1px solid #e2e8f0", paddingBottom: "12px", marginBottom: "20px" }}>
//           {[
//             { id: "headline", label: "1. Headline Info" },
//             { id: "batch", label: "2. Batch Details" },
//             { id: "pricing", label: "3. Pricing & Time" },
//             { id: "syllabus", label: "4. Syllabus & Schedule" },
//             { id: "questions", label: "5. Questions & PDF" },
//             { id: "omr", label: "6. OMR & Keys" }
//           ].map((step) => (
//             <button
//               key={step.id}
//               className={tab === step.id ? "active" : ""}
//               onClick={() => {
//                 if (canNavigateTo(step.id)) {
//                   setTab(step.id);
//                 }
//               }}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "20px",
//                 fontSize: "14px",
//                 fontWeight: "500",
//                 border: "1px solid",
//                 borderColor: tab === step.id ? "#2563eb" : "#e2e8f0",
//                 background: tab === step.id ? "#eff6ff" : "#fff",
//                 color: tab === step.id ? "#2563eb" : "#64748b",
//                 cursor: "pointer",
//                 transition: "all 0.2s ease"
//               }}
//             >
//               {step.label}
//             </button>
//           ))}
//         </div>

//         <div className="card-body">
//           {tab === "headline" && (
//             <div className="headline-content">
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Heading Tagline :</label>
//                   <input
//                     name="headlineTagline"
//                     value={formData.headlineTagline}
//                     onChange={handleInputChange}
//                     onFocus={() => setFocusedField("headlineTagline")}
//                     onBlur={() => setFocusedField("")}
//                     className={focusedField === "headlineTagline" ? "blue-btn" : ""}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter headline tagline"
//                   />
//                   {errors.headlineTagline && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.headlineTagline}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Banner Tagline :</label>
//                   <textarea
//                     name="bannerTagline"
//                     value={formData.bannerTagline}
//                     onChange={handleInputChange}
//                     onFocus={() => setFocusedField("bannerTagline")}
//                     onBlur={() => setFocusedField("")}
//                     className={focusedField === "bannerTagline" ? "blue-btn" : ""}
//                     rows={2}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter banner tagline"
//                   />
//                   {errors.bannerTagline && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.bannerTagline}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="footer-row" style={{ marginTop: "40px", display: "flex", justifyContent: "flex-end" }}>
//                 <button
//                   className="next-btn-upload"
//                   onClick={() => {
//                     if (validateStep("headline")) {
//                       setTab("batch");
//                     }
//                   }}
//                 >
//                   Next <ChevronRight size={18} />
//                 </button>
//               </div>
//             </div>
//           )}

//           {tab === "batch" && (
//             <div className="headline-content">
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Test Batch Name :</label>
//                   <input
//                     name="testBatchName"
//                     value={formData.testBatchName}
//                     onChange={handleInputChange}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter test batch name"
//                   />
//                   {errors.testBatchName && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.testBatchName}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Sub Topic :</label>
//                   <input
//                     name="subTopic"
//                     value={formData.subTopic}
//                     onChange={handleInputChange}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter sub topic"
//                   />
//                   {errors.subTopic && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.subTopic}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="footer-row" style={{ marginTop: "40px", display: "flex", justifyContent: "space-between" }}>
//                 <button
//                   className="next-btn-upload"
//                   style={{ background: "#cbd5e1", color: "#475569" }}
//                   onClick={() => setTab("headline")}
//                 >
//                   <ChevronLeft size={18} /> Previous
//                 </button>
//                 <button
//                   className="next-btn-upload"
//                   onClick={() => {
//                     if (validateStep("batch")) {
//                       setTab("pricing");
//                     }
//                   }}
//                 >
//                   Next <ChevronRight size={18} />
//                 </button>
//               </div>
//             </div>
//           )}

//           {tab === "pricing" && (
//             <div className="headline-content">
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Test Fees :</label>
//                   <input
//                     type="number"
//                     name="testFees"
//                     value={formData.testFees}
//                     onChange={handleInputChange}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter Fee"
//                   />
//                   {errors.testFees && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.testFees}</p>
//                   )}
//                 </div>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Exam Duration (Minutes):</label>
//                   <input
//                     name="examduration"
//                     value={formData.examduration}
//                     onChange={handleInputChange}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter exam duration"
//                   />
//                   {errors.examduration && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.examduration}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="footer-row" style={{ marginTop: "40px", display: "flex", justifyContent: "space-between" }}>
//                 <button
//                   className="next-btn-upload"
//                   style={{ background: "#cbd5e1", color: "#475569" }}
//                   onClick={() => setTab("batch")}
//                 >
//                   <ChevronLeft size={18} /> Previous
//                 </button>
//                 <button
//                   className="next-btn-upload"
//                   onClick={() => {
//                     if (validateStep("pricing")) {
//                       setTab("syllabus");
//                     }
//                   }}
//                 >
//                   Next <ChevronRight size={18} />
//                 </button>
//               </div>
//             </div>
//           )}

//           {tab === "syllabus" && (
//             <div className="headline-content">
//               <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "24px" }}>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Syllabus :</label>
//                   <textarea
//                     name="syllabus"
//                     value={formData.syllabus}
//                     onChange={handleInputChange}
//                     rows={4}
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter syllabus details"
//                   />
//                   {errors.syllabus && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.syllabus}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="divider" style={{ margin: "24px 0" }}></div>
//               <div className="footer-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
//                 <div className="schedule-box">
//                   <span style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Schedule PDF</span>
//                   <input
//                     type="file"
//                     accept=".pdf"
//                     onChange={(e) =>
//                       handleFileUpload("schedulePdf", e.target.files[0])
//                     }
//                     style={{ display: "none" }}
//                     id="schedulePdf"
//                   />
//                   <label htmlFor="schedulePdf" className={formData.schedulePdf ? "uploaded-btn-small" : "upload-btn-small"} style={{ cursor: "pointer" }}>
//                     {formData.schedulePdf ? "Uploaded PDF" : "Upload PDF"}
//                   </label>
//                   {formData.schedulePdf && (
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
//                       <a
//                         href={formData.schedulePdf.url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="pdf-link"
//                       >
//                         <span className="pdf-icon">📄</span>
//                         <span className="pdf-name">
//                           {formData.schedulePdf.name}
//                         </span>
//                       </a>
//                       <button
//                         onClick={() => handleRemovePdf("schedulePdf")}
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           cursor: "pointer",
//                           fontSize: "18px",
//                           color: "red"
//                         }}
//                       >
//                         <IoClose />
//                       </button>
//                     </div>
//                   )}
//                   {errors.schedulePdf && (
//                     <p className="error-text" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.schedulePdf}</p>
//                   )}
//                 </div>
//                 <div style={{ display: "flex", gap: "10px" }}>
//                   <button
//                     className="next-btn-upload"
//                     style={{ background: "#cbd5e1", color: "#475569" }}
//                     onClick={() => setTab("pricing")}
//                   >
//                     <ChevronLeft size={18} /> Previous
//                   </button>
//                   <button
//                     className="next-btn-upload"
//                     onClick={() => {
//                       if (validateStep("syllabus")) {
//                         setTab("questions");
//                       }
//                     }}
//                   >
//                     Next <ChevronRight size={18} />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {tab === "questions" && (
//             <div className="questions-content">
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1.2fr", gap: "24px", alignItems: "end" }}>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Test No :</label>
//                   <div className="confirm-box">
//                     <input
//                       type="text"
//                       value={formData.testNo}
//                       style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                       onChange={(e) =>
//                         setFormData((prev) => ({
//                           ...prev,
//                           testNo: e.target.value,
//                         }))
//                       }
//                       min="1"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Total Questions :</label>
//                   <div className="confirm-box">
//                     <input
//                       type="number"
//                       value={totalQuestions}
//                       style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                       onChange={(e) => setTotalQuestions(e.target.value)}
//                       min="1"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <span style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Question PDF</span>
//                   <div className="upload-card" style={{ width: "100%", height: "46px", marginTop: "0", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 16px", border: "1px solid #cbd5e1", borderRadius: "8px" }}>
//                     <span style={{ fontSize: "14px", color: "#64748b" }}>PDF Document</span>
//                     <input
//                       type="file"
//                       accept=".pdf"
//                       onChange={(e) =>
//                         handleFileUpload("questionPdf", e.target.files[0])
//                       }
//                       style={{ display: "none" }}
//                       id="questionPdf"
//                     />
//                     <label htmlFor="questionPdf" className={formData.questionPdf ? "green-text-btn" : "blue-text-btn "} style={{ cursor: "pointer", margin: "0" }}>
//                       <Upload size={14} /> {formData.questionPdf ? "Uploaded" : "Upload"}
//                     </label>
//                   </div>
//                 </div>
//               </div>
//               {formData.questionPdf && (
//                 <div style={{ display: "flex", alignItems: "center", marginTop: "15px", gap: "10px" }}>
//                   <a
//                     href={formData.questionPdf.url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="pdf-link"
//                   >
//                     <span className="pdf-icon">📄</span>
//                     <span className="pdf-name">{formData.questionPdf.name}</span>
//                   </a>
//                   <button
//                     onClick={() => handleRemovePdf("questionPdf")}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                       fontSize: "18px",
//                       color: "red"
//                     }}
//                   >
//                     <IoClose />
//                   </button>
//                 </div>
//               )}
//               <div className="footer-row" style={{ marginTop: "40px", display: "flex", justifyContent: "space-between" }}>
//                 <button
//                   className="next-btn-upload"
//                   style={{ background: "#cbd5e1", color: "#475569" }}
//                   onClick={() => setTab("syllabus")}
//                 >
//                   <ChevronLeft size={18} /> Previous
//                 </button>
//                 <button
//                   className="next-btn-upload"
//                   onClick={() => setTab("omr")}
//                 >
//                   Next <ChevronRight size={18} />
//                 </button>
//               </div>
//             </div>
//           )}

//           {tab === "omr" && (
//             <div className="questions-content">
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", alignItems: "start" }}>
//                 <div>
//                   <span style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>OMR Sheet Template</span>
//                   <div
//                     className="upload-card"
//                     style={{ width: "100%", height: "46px", marginTop: "0", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 16px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                   >
//                     <span style={{ fontSize: "14px", color: "#64748b" }}>OMR Sheet Document</span>
//                     {formData.omrsheet ? (
//                       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                         <div className="blue-text-btn" onClick={handleOMRDownload} style={{ marginTop: 0, cursor: "pointer" }}>
//                           <Download size={14} /> Download
//                         </div>
//                         <button
//                           onClick={() => handleRemovePdf("omrsheet")}
//                           style={{
//                             border: "none",
//                             background: "transparent",
//                             cursor: "pointer",
//                             fontSize: "18px",
//                             color: "red",
//                             display: "flex",
//                             alignItems: "center"
//                           }}
//                         >
//                           <IoClose />
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="blue-text-btn" onClick={() => setOmrModalOpen(true)} style={{ marginTop: 0, cursor: "pointer" }}>
//                         <Upload size={14} /> Upload
//                       </div>
//                     )}
//                   </div>
//                   <div className="omr-card" style={{ marginTop: "10px" }}>
//                     <span style={{ color: "#FF0000", fontSize: "12px" }}>
//                       Our OMR scanner captures responses with around 90–95% accuracy.
//                       <br />
//                       {formData.omrsheet ? "Download the selected OMR sheet template." : "Upload an OMR Sheet template to be used for this batch."}
//                     </span>
//                   </div>
//                 </div>

//                 <div>
//                   <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Video Link :</label>
//                   <input
//                     type="text"
//                     name="videoLink"
//                     value={formData.videoLink}
//                     onChange={handleInputChange}
//                     className="video-url-input"
//                     style={{ width: "100%", padding: "10px", border: "1px solid #cbd5e1", borderRadius: "8px" }}
//                     placeholder="Enter video link"
//                   />
//                 </div>
//               </div>

//               <div style={{ marginTop: "30px" }}>
//                 <span style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>Answer Key Configuration :</span>
//                 <div className="answer-card-container" onClick={handleNavigateToOMR} style={{ cursor: "pointer", maxWidth: "320px" }}>
//                   <div className="answer-card" style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px" }}>
//                     <button style={{ border: "none", background: "none", color: "#1e293b", fontWeight: "600", fontSize: "14px", cursor: "pointer" }}>Configure Answers</button>
//                     <div className="eye-icon" style={{ color: "#64748b" }}>
//                       <Eye size={18} />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="publish-row" style={{ marginTop: "40px", display: "flex", justifyContent: "space-between" }}>
//                 <button
//                   className="next-btn-upload"
//                   style={{ background: "#cbd5e1", color: "#475569" }}
//                   onClick={() => setTab("questions")}
//                 >
//                   <ChevronLeft size={18} /> Previous
//                 </button>
//                 <button
//                   className="publish-btn"
//                   onClick={handlePublish}
//                 >
//                   {loading ? "Publishing..." : "Publish"}
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {openDialog && (
//         <div className="modal-overlay">
//           <div className="crop-modal">
//             <div className="modal-header">
//               <h3> {isExam ? "Add New Exam" : "Add Sub New Exam"}</h3>
//               <button
//                 className="close-modal"
//                 onClick={() => {
//                   setShowAddInput(false);
//                   setOpenDialog(false);
//                 }}
//               >
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body-exam">
//               {showAddInput && (
//                 <div className="input-box single">
//                   <input
//                     type="text"
//                     value={newExamValue}
//                     onChange={(e) => setNewExamValue(e.target.value)}
//                     placeholder="Enter new exam"
//                   />

//                   <div className="add-btn-wrapper">
//                     <button className="add-btn" onClick={() => handleAddExam()}>
//                       <span className="plus">+</span>
//                       <span className="text">Create</span>
//                     </button>
//                   </div>
//                 </div>
//               )}
//               <div
//                 className="exam-checkbox-list"
//                 style={{
//                   display: isExam
//                     ? allexamOptions.length > 0
//                       ? "grid"
//                       : "block"
//                     : filteredSubExams.length > 0
//                       ? "grid"
//                       : "block",
//                 }}
//               >
//                 {isExam ? (
//                   allexamOptions.length > 0 ? (
//                     allexamOptions.map((exam) => (
//                       <label
//                         key={exam.id || exam.value}
//                         className="exam-checkbox-item"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={isExamChecked(exam)}
//                           onChange={() => handleAddExamClick(exam)}
//                         />
//                         <span className="check-label">{exam.label}</span>
//                       </label>
//                     ))
//                   ) : (
//                     <div className="no-data-upload">
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="no-data-upload-icon"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
//                         />
//                       </svg>
//                       <span>No exams found</span>
//                     </div>
//                   )
//                 ) : filteredSubExams.length > 0 ? (
//                   filteredSubExams.map((exam) => {
//                     const checked = isExamChecked(exam);
//                     return (
//                       <label
//                         key={exam.id || exam.value}
//                         className={`exam-checkbox-item ${checked ? "active" : ""}`}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleAddExamClick(exam);
//                         }}
//                       >
//                         <span className="check-label">{exam.label}</span>
//                         {checked && <span className="close-icon">✕</span>}
//                       </label>
//                     );
//                   })
//                 ) : (
//                   <div className="no-data-upload" style={{ width: "90%" }}>
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="no-data-upload-icon"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
//                       />
//                     </svg>
//                     <span>No exams found</span>
//                   </div>
//                 )}

//                 {!showAddInput && (
//                   <div
//                     className="exam-checkbox-item add-exam"
//                     onClick={() => setShowAddInput(true)}
//                   >
//                     <span className="plus-icon">+</span>
//                     <span className="check-label">Create</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//             {/* {isExam && ( */}
//             <div className="crop-actions">
//               <button
//                 className="cancel-crop-btn"
//                 onClick={() => {
//                   setShowAddInput(false);
//                   setOpenDialog(false);
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="apply-crop-btn"
//                 onClick={() => handleAddExam()}
//               >
//                 Save
//               </button>
//             </div>
//             {/* )} */}
//           </div>
//         </div>
//       )}

//       {omrModalOpen && (
//         <div className="modal-overlay">
//           <div className="crop-modal" style={{ maxWidth: "600px" }}>
//             <div className="modal-header">
//               <h3>Select OMR Sheet Template</h3>
//               <button
//                 className="close-modal"
//                 onClick={() => setOmrModalOpen(false)}
//               >
//                 <FiX />
//               </button>
//             </div>
//             <div className="modal-body-exam" style={{ maxHeight: "400px", overflowY: "auto" }}>
//               <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", padding: "10px" }}>
//                 {[
//                   { name: "OMR 20 Questions", src: OMR_20, questions: 20 },
//                   { name: "OMR 50 Questions", src: OMR_50, questions: 50 },
//                   { name: "OMR 100 Questions", src: OMR_100, questions: 100 },
//                   { name: "OMR 150 Questions", src: OMR_150, questions: 150 },
//                   { name: "OMR 200 Questions", src: OMR_200, questions: 200 }
//                 ].map((template) => (
//                   <div 
//                     key={template.name}
//                     className="omr-template-card"
//                     style={{
//                       border: "1px solid #ddd",
//                       borderRadius: "8px",
//                       padding: "10px",
//                       textAlign: "center",
//                       cursor: "pointer",
//                       transition: "all 0.3s ease",
//                       background: "#fdfdfd"
//                     }}
//                     onClick={() => handleSelectOMR(template.name, template.src)}
//                   >
//                     <div style={{ height: "120px", overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #eee", borderRadius: "4px", marginBottom: "10px", background: "#fff" }}>
//                       <img src={template.src} alt={template.name} style={{ height: "100%", objectFit: "contain" }} />
//                     </div>
//                     <span style={{ fontWeight: "600", fontSize: "14px" }}>{template.name}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="crop-actions">
//               <button
//                 className="cancel-crop-btn"
//                 onClick={() => setOmrModalOpen(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadPage;




import React, { useEffect, useState } from "react";
import { ChevronRight, Upload, Download, Eye, X, ChevronLeft } from "lucide-react";
import "../../styles/upload.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef } from "react";
import Firstphoto from "../../assets/uploadpage1.png";
import Scoundphoto from "../../assets/uploadpage2.png";
import { IoClose } from "react-icons/io5";
import OMRPDF from "../../assets/omrimages/OMRPDF.png";
import OMR_20 from "../../assets/omrimages/20-OMR-EMPTY-Q.png";
import OMR_50 from "../../assets/omrimages/50-OMR-EMPTY-Q.png";
import OMR_100 from "../../assets/omrimages/100-OMR-EMPTY-Q.png";
import OMR_150 from "../../assets/omrimages/150-OMR-EMPTY-Q.png";
import OMR_200 from "../../assets/omrimages/200-OMR-EMPTY.png";
import { useDispatch, useSelector } from "react-redux";
import {
  masterdata_create,
  masterdata_list,
  students_profile,
  institution_dashboard,
  batch_create,
  update_profile,
  masterdata_update,
  user_exams_add,
} from "../../util/Apiendpoits";
import {
  deleteWithTokenAPI,
  deleteWithTokenAPIpayload,
  getWithoutTokenAPI,
  getWithTokenAPI,
  ImageUpload,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../../util/Api";
import { FiBook, FiX } from "react-icons/fi";
import Select from "react-select";
import { SafeToast } from "../Toast/ShowToast";
import SelectDropdown from "../ReusableComponent/SelectDropdown";
import { setProfileData } from "../../store/profileSlice";

const UploadPage = () => {
  const location = useLocation();
  const isReturningFromOMR = location.state?.activeTab === "questions";

  // Clear local storage on initial mount if not returning from OMR sheet configuration
  if (!isReturningFromOMR) {
    localStorage.removeItem("uploadFormData");
    localStorage.removeItem("totalQuestions");
    localStorage.removeItem("omrAnswers");
    localStorage.removeItem("allOmrAnswers");
    localStorage.removeItem("testBatches");
    localStorage.removeItem("numberOfTesting");
    localStorage.removeItem("currentTestIndex");
  }

  const [tab, setTab] = useState(() => {
    // if (location.state?.activeTab) {
    //     return location.state.activeTab;
    // }
    const saved = localStorage.getItem("uploadFormData");
    return saved ? "headline" : "headline";
  });
  const [totalQuestions, setTotalQuestions] = useState(() => {
    const saved = localStorage.getItem("totalQuestions");
    return saved ? parseInt(saved) : 0;
  });

  const [answers, setAnswers] = useState(() => {
    const saved = localStorage.getItem("omrAnswers");
    return saved ? JSON.parse(saved) : {};
  });


  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile);
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const [examOptions, setExamOptions] = useState([]);
  const [allexamOptions, setAllExamOptions] = useState([]);

  const [allSubexamOptions, setSubAllExamOptions] = useState([]);
  const [subExamOptions, setSubExamOptions] = useState([]);
  const [Institutionprofile, setInstitutionprofile] = useState(null);
  
  const [lastUpdatedQuestions, setLastUpdatedQuestions] = useState(0);


  console.log(lastUpdatedQuestions,"lastUpdatedQuestions")
  const [openDialog, setOpenDialog] = useState(false);
  const [showAddInput, setShowAddInput] = useState(false);
  const [newExamValue, setNewExamValue] = useState("");
  const dispatch = useDispatch();
  const [examName, setExamName] = useState("");
  const isExam = examName?.toLowerCase().trim() === "exam";
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(() => {
    const savedFormData = localStorage.getItem("uploadFormData");
    if (savedFormData) {
      return JSON.parse(savedFormData);
    }
    return {
      headlineTagline: "",
      bannerTagline: "",
      testFees: "",
      testBatchName: "",
      subTopic: "",
      syllabus: "",
      schedulePdf: "",
      testNo: "1",
      questionPdf: "",
      answerPdf: "",
      videoLink: "",
      omrsheet: "",
      examduration: ""
    };
  });

  const [batchOptions, setBatchOptions] = useState([]);
  const [showBatchInput, setShowBatchInput] = useState(false);
  const getParsedItem = (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (err) {
      console.warn(`Invalid JSON in localStorage for ${key}`);
      localStorage.removeItem(key); // cleanup bad data
      return null;
    }
  };

  const [activeExam, setActiveExam] = useState(() =>
    getParsedItem("activeExam"),
  );

  const [activeSubExam, setActiveSubExam] = useState(() =>
    getParsedItem("activeSubExam"),
  );

  useEffect(() => { }, [profile]);
  useEffect(() => {
    if (activeExam !== null) {
      localStorage.setItem("activeExam", JSON.stringify(activeExam));
    }
  }, [activeExam]);

  useEffect(() => {
    if (activeSubExam !== null) {
      localStorage.setItem("activeSubExam", JSON.stringify(activeSubExam));
    }
  }, [activeSubExam]);

  // Dashboard stats
  const [dashboardStats, setDashboardStats] = useState({
    totalStudents: 0,
    totalBatches: 0,
  });

  const [loading, setLoading] = useState(false);
  const tabsRef = useRef(null);
  const ExamtabsRef = useRef(null);
  const prevTestNoRef = useRef("");


  const handleRemovePdf = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: null
    }));
  };



  const fetchExamOptions = async () => {
    try {
      const response = await getWithoutTokenAPI(masterdata_list);

      if (response.statusCode === 200) {
        const options = response.data
          .filter(
            (item) => item.type === "examType" && item.status === "active",
          )
          .map((item) => ({
            value: item.code,
            label: item.value,
            id: item._id,
          }));
        setAllExamOptions(options);

        const Suboptions = response.data
          .filter(
            (item) => item.type === "subexamType" && item.status === "active",
          )
          .map((item) => ({
            value: item.code,
            label: item.value,
            id: item._id,
          }));
        setSubAllExamOptions(Suboptions);
      }
    } catch (error) {
      console.error("Error fetching exam options:", error);
    }
  };

  useEffect(() => {
    fetchExamOptions();
  }, []);

  useEffect(() => {
    localStorage.setItem("uploadFormData", JSON.stringify(formData));
  }, [formData]);

  // Save total questions to localStorage
  useEffect(() => {
    localStorage.setItem("totalQuestions", totalQuestions);
  }, [totalQuestions]);

  // Save answers to localStorage
  useEffect(() => {
    localStorage.setItem("omrAnswers", JSON.stringify(answers));
  }, [answers]);

  // Fetch institution profile
  useEffect(() => {
    if (roleType !== "institution_admin") return;
    const fetchProfile = async () => {
      try {
        const updateRes = await getWithTokenAPI(
          token,
          `${students_profile}${userId}`,
        );

        if (updateRes?.statusCode === 200) {
          setInstitutionprofile(updateRes.data);
        }
      } catch (error) {
        console.log("Failed to load institution profile");
        SafeToast.error("Failed to load profile");
      }
    };

    fetchProfile();
  }, [roleType, token, userId]);



  const fetchBatchNames = async () => {
    try {

      if (!Institutionprofile?._id) return;

      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}&BatchNames=true&examType=${activeExam.value}`
      );


      if (response?.statusCode === 200) {

        // API ARRAY
        const batchArray = response?.data?.data || [];

        // REMOVE EMPTY OBJECTS + DUPLICATES
        const uniqueBatches = [
          ...new Map(
            batchArray
              .filter((item) => item?.testBatchName)
              .map((item) => [
                item.testBatchName,
                {
                  label: item.testBatchName,
                  value: item.testBatchName,
                },
              ])
          ).values(),
        ];

        console.log(uniqueBatches, "uniqueBatches");

        setBatchOptions(uniqueBatches);
      }

    } catch (err) {
      console.log(err);
    }
  };

  // CALL WHEN EXAM CHANGES
  useEffect(() => {
    fetchBatchNames();
    setFormData((prev) => ({
      ...prev,
      testBatchName: "",
    }));
    setShowBatchInput(false);
    setTests([
      {
        testNo: "",
        totalQuestions: "",
        questionPdf: null,
        omrsheet: null,
        videoLink: "",
      },
    ]);
  }, [activeExam, Institutionprofile]);

  const fetchUserExams = async () => {
    try {
      const response = await getWithTokenAPI(token, `/user/${userId}/exams`);

      if (response?.statusCode === 200) {
        const examOpts = response.data.exams.map((exam) => ({
          value: exam._id,
          label: exam.value,
          code: exam.code,
          id: exam._id,
        }));
        setExamOptions(examOpts);

        const subExamOpts = response.data.subexams.map((subexam) => ({
          value: subexam._id,
          label: subexam.value,
          parentCode: subexam.code,
          id: subexam._id,
        }));
        setSubExamOptions(subExamOpts);
      }
    } catch (error) {
      console.error("Error fetching user exams:", error);
      SafeToast.error("Failed to load exams");
    }
  };
  useEffect(() => {
    if (!userId) return;
    fetchUserExams();
  }, [userId, token]);

  // Fetch dashboard statistics
  const fetchDashboardStats = async () => {
    try {
      const response = await getWithTokenAPI(
        token,
        `${institution_dashboard}${userId}`,
      );

      if (response?.success) {
        setDashboardStats({
          totalStudents: response.data?.totalStudents || 0,
          totalBatches: response.data?.totalBatches || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      SafeToast.error("Failed to load dashboard statistics");
    }
  };
  useEffect(() => {
    if (roleType !== "institution_admin" || !userId) return;

    fetchDashboardStats();
  }, [roleType, token, userId]);

  const handleAddExam = async () => {
    if (!newExamValue) {
      SafeToast.success("Exams Updated successfully!");
      setShowAddInput(false);
      setOpenDialog(false);
      return null;
    }
    const newExam = {
      code:
        examName === "exam" ? allSubexamOptions.length + 1 : activeExam.code,
      value: newExamValue,
      type: examName === "exam" ? "examType" : "subexamType",
      status: "active",
    };

    try {
      const response = await postWithoutTokenAPI(masterdata_create, newExam);
      if (response.statusCode === 200 || response.statusCode === 201) {
        const option = {
          value: response.data?._id || newExam.code,
          label: newExam.value,
          code: newExam.code,
        };
        fetchExamOptions();
        if (examName == "exam") {
          setAllExamOptions((prev) => [...prev, option]);
        } else {
          setSubExamOptions((prev) => {
            const relatedSubs = prev.filter(
              (sub) => sub.parentCode === activeExam.code,
            );
            const exists = relatedSubs.some(
              (sub) => sub.value === option.value,
            );

            if (exists) {
              return prev.filter((sub) => sub.value !== option.value);
            } else {
              const newOption = {
                ...option,
                parentCode: activeExam.code,
              };

              return [...prev, newOption];
            }
          });
        }

        setNewExamValue("");
        setShowAddInput(false);
        SafeToast.success("New exam added successfully!");
      }
    } catch (error) {
      console.error("Error creating new exam:", error);
      SafeToast.error("Failed to add new exam");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const uploadFile = async (type, file) => {
    // const MAX_SIZE = 50 * 1024 * 1024; 

    // if (file.size > MAX_SIZE) {
    //   SafeToast.error("Maximum allowed PDF size is 45 MB");
    //   return null;
    // }
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await ImageUpload(
        `/upload_image?userId=${userId}&type=${roleType}`,
        formData,
        true,
      );
      if (response.statusCode === 413) {
        SafeToast.error("Maximum allowed PDF size is 45 MB");
      }
      if (response.statusCode === 200) {
        return response?.data?.[0]?.fileUrl || null;
      }

    }
    catch (error) {
      SafeToast.error("Maximum allowed PDF size is 45 MB");
      return null;
    }
  };

  const handleFileUpload = async (fileType, file) => {
    const fileUrl = await uploadFile(fileType, file);

    if (!fileUrl) return;

    setFormData((prev) => ({
      ...prev,
      [fileType]: {
        name: file.name,
        url: fileUrl,
      },
    }));

    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[fileType];
      return updatedErrors;
    });

    SafeToast.success(
      `${fileType.replace(/([A-Z])/g, " $1")} uploaded successfully`,
    );
  };

  const handleExamClick = (exam) => {
    setActiveExam(exam);

    const related = subExamOptions.filter(
      (sub) => sub.parentCode === exam.code,
    );

    setActiveSubExam((prev) =>
      related.some((s) => s.id === prev?.id) ? prev : related[0] || null,
    );
  };

  const handleCreateExamBatch = async () => {

    const count = Number(numberOfTesting);

    if (!count || count < 1) {
      SafeToast.error("Please enter valid Number of Testing");
      return;
    }

    if (!activeExam?.value) {
      SafeToast.error("Select Exam");
      return;
    }

    if (!formData.testBatchName) {
      SafeToast.error("Enter Batch Name");
      return;
    }

    setLoading(true);

    try {
      const validExistingTests = tests.filter((t) => t.testNo && t.testNo !== "");
      const existingCount = validExistingTests.length;



      console.log("Existing tests count:", existingCount);
      console.log("count tests count:", count);
      if (count <= existingCount) {
        SafeToast.info("No new tests to add. Existing tests preserved.");
        setLoading(false);
        return;
      }

      // ✅ Generate only the new ones
      const testsToCreate = [];
      for (let i = existingCount + 1; i <= count; i++) {
        testsToCreate.push({
          testNo: `${i}`,
          totalQuestions: "",
          questionPdf: null,
          omrsheet: null,
          videoLink: "",
          isPublished: false,
        });
      }

      // ✅ UI UPDATE PRE-EMPTIVELY
      const updatedTests = [...validExistingTests, ...testsToCreate];
      setTests(updatedTests);

      // ✅ API SAVE ONLY NEWLY GENERATED TESTS
      for (const test of testsToCreate) {
        const batchData = {
          Institution_id: Institutionprofile._id,

          examType: activeExam.value,


          testFees: parseInt(formData.testFees) || 0,

          testBatchName: formData.testBatchName,


          schedulePdf:
            formData?.schedulePdf?.url || "",

          testNo: parseInt(test.testNo),

          totalQuestions: 0,

          numberofTests: count,

          isPublished: false,

          questionFiles: {
            questionPdf: "",
            answerPdf: "",
            videoLink: "",
            answers: [],
            omrsheet: "",
          },
        };

        await postWithTokenAPI(
          token,
          batch_create,
          batchData
        );
      }

      // KEEP CURRENT TEST
      const currentIndex = currentTestIndex;

      // OPTIONAL REFRESH
      await fetchBatchList();

      // RESTORE CURRENT TEST
      setCurrentTestIndex(currentIndex);

      // ✅ REFRESH DROPDOWN OPTIONS LIST
      await fetchBatchNames();

      // ✅ AUTOMATICALLY SWITCH FROM TEXT INPUT BACK TO SELECT DROPDOWN
      setShowBatchInput(false);

      SafeToast.success("New exam batches created");

    } catch (error) {

      console.log(error);

      SafeToast.error("Failed to create batch");

    } finally {

      setLoading(false);

    }
  };


  const fetchBatchList = async () => {

    try {

      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}&examType=${activeExam.value}&testBatchName=${formData.testBatchName}`
      );

      console.log(response, "REFETCHED BATCHES");

      if (response?.statusCode === 200) {

        const batches = response?.data?.data || [];

        const latestPublishedBatch = batches
          .filter((item) => item.isPublished && item.totalQuestions)
          .sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          )[0];

        const calculatedLastUpdatedQuestions = latestPublishedBatch?.totalQuestions || 0;
        setLastUpdatedQuestions(calculatedLastUpdatedQuestions);

        // ✅ REMOVE DUPLICATES USING testNo
        const uniqueTests = [
          ...new Map(
            batches.map((item) => [
              item.testNo,
              item
            ])
          ).values()
        ];

        // ✅ SORT ASCENDING
        uniqueTests.sort((a, b) => a.testNo - b.testNo);

        const mappedTests = uniqueTests.map((item) => ({
          _id: item?._id || "",

          testNo: item?.testNo || "",

          totalQuestions: (item?.totalQuestions && parseInt(item.totalQuestions) > 0)
            ? item.totalQuestions
            : (calculatedLastUpdatedQuestions || ""),

          questionPdf: item?.questionFiles?.questionPdf
            ? {
              name: "Question PDF",
              url: item.questionFiles.questionPdf,
            }
            : null,

          omrsheet: item?.questionFiles?.omrsheet
            ? {
              name: "OMR Sheet",
              url: item.questionFiles.omrsheet,
            }
            : null,

          videoLink: item?.questionFiles?.videoLink || "",

          answers: item?.questionFiles?.answers || [],

          isPublished: item?.isPublished || false,
        }));

        setTests(mappedTests);

        setNumberOfTesting(mappedTests.length);

      }

    } catch (error) {

      console.log(error);

    }
  };


  const handlePublish = async () => {

    if (loading) return;

    if (!activeExam?.value) {
      SafeToast.error("Select Exam");
      return;
    }

    setLoading(true);

    try {

      // ✅ CURRENT TEST
      const currentTest = tests[currentTestIndex];

      if (!currentTest) {
        SafeToast.error("No Test Found");
        return;
      }

      // ✅ ALREADY PUBLISHED
      // if (currentTest.isPublished) {
      //   SafeToast.error("Already Published");
      //   return;
      // }

      // ✅ ANSWERS
      const answersArray = Object.entries(answers)
        .filter(([_, value]) => value)
        .map(([questionNumber, correctAnswer]) => ({
          questionNumber: parseInt(questionNumber),
          correctAnswer,
        }));

      let questionPdfUrl = "";

      // ✅ PDF UPLOAD
      if (currentTest.questionPdf instanceof File) {

        const uploaded = await uploadFile(
          "questionPdf",
          currentTest.questionPdf
        );

        if (uploaded) {
          questionPdfUrl = uploaded;
        }

      } else {

        questionPdfUrl =
          currentTest.questionPdf?.url || "";

      }

      // ✅ API DATA
      const batchData = {

        Institution_id: Institutionprofile._id,

        examType: activeExam.value,



        testFees: parseInt(formData.testFees) || 0,

        testBatchName: formData.testBatchName || "",



        schedulePdf:
          formData?.schedulePdf?.url || "",

        testNo: parseInt(currentTest.testNo),

        totalQuestions: parseInt(
          currentTest.totalQuestions || lastUpdatedQuestions || 0
        ) || 0,

        numberofTests: numberOfTesting,

        isPublished: true,

        questionFiles: {

          questionPdf: questionPdfUrl,

          answerPdf:
            formData?.answerPdf?.url || "",

          videoLink:
            currentTest.videoLink || "",

          answers: answersArray,

          omrsheet:
            currentTest.omrsheet?.url || "",
        },
      };

      // ✅ IMPORTANT
      // UPDATE EXISTING TEST
      const response = await putWithTokenAPI(
        token,
        `/batch/update/${currentTest._id}`,
        batchData
      );

      if (
        response?.statusCode === 200 ||
        response?.statusCode === 201
      ) {

        // ✅ UPDATE ONLY CURRENT TEST
        setTests((prev) =>
          prev.map((t, index) =>
            index === currentTestIndex
              ? {
                ...t,
                isPublished: true,
              }
              : t
          )
        );

        SafeToast.success(
          `Test ${currentTest.testNo} Updated Successfully`
        );

        // ✅ KEEP CURRENT INDEX
        const currentIndex = currentTestIndex;

        // ✅ REFRESH DATA
        await fetchBatchList();

        // ✅ RESTORE INDEX
        setCurrentTestIndex(currentIndex);
      }

    } catch (error) {

      console.log(error);

      SafeToast.error("Publish Failed");

    } finally {

      setLoading(false);

    }
  };


  const ExamscrollLeft = () => {
    if (ExamtabsRef.current) {
      ExamtabsRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const ExamscrollRight = () => {
    if (ExamtabsRef.current) {
      ExamtabsRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };



  const handleNavigateToOMR = () => {
    localStorage.setItem("uploadFormData", JSON.stringify(formData));

    let finalAnswers = answers;
    const currentTest = tests[currentTestIndex];

    console.log(currentTest, 'currentTest')
    if (
      (!finalAnswers || Object.keys(finalAnswers).length === 0) &&
      currentTest?.answers?.length > 0
    ) {
      const formattedAnswers = {};
      currentTest.answers.forEach((ans) => {
        if (ans.questionNumber && ans.correctAnswer) {
          formattedAnswers[ans.questionNumber] = ans.correctAnswer;
        }
      });
      finalAnswers = formattedAnswers;
      setAnswers(formattedAnswers);
    }

    localStorage.setItem("omrAnswers", JSON.stringify(finalAnswers));

    console.log(finalAnswers, "ANSWERS");
    // Use the current test card's totalQuestions so OMR page generates correct slots
    const currentTestQuestions = tests[currentTestIndex]?.totalQuestions || totalQuestions || 0;
    localStorage.setItem("totalQuestions", currentTestQuestions);
    // Persist test batch state so it survives navigation
    localStorage.setItem("testBatches", JSON.stringify(tests));
    localStorage.setItem("numberOfTesting", numberOfTesting);
    localStorage.setItem("currentTestIndex", currentTestIndex);


    // tests[currentTestIndex]?.videoLink
    navigate("/omr");
  };

  const isExamChecked = (exam) => {
    if (isExam) {
      return examOptions.some((ex) => ex.code === exam.value);
    } else {
      return subExamOptions.some(
        (sub) => (sub.id || sub.value) === (exam.id || exam.value),
      );
    }
  };






  const filteredSubExams = activeExam
    ? allSubexamOptions.filter((sub) => sub.value === activeExam.code)
    : [];

  const deleteUserExam = async ({ exams = [], subexams = [] }) => {
    if (!token || !userId) {
      console.warn("Missing token or userId");
      return;
    }

    if (!exams.length && !subexams.length) {
      console.warn("Nothing to delete");
      return;
    }

    try {
      const res = await deleteWithTokenAPIpayload(
        token,
        `/user/${userId}/exams-remove`,
        {
          exams,
          subexams,
        },
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Removed successfully");
      } else {
        SafeToast.error(res?.message || "Remove failed");
      }
    } catch (error) {
      console.error("Delete exam error:", error);
      SafeToast.error("Delete failed");
    }
  };
  const getExamId = (exam) => exam?.id || exam?.value || null;


  const handleAddExamClick = async (exam) => {
    if (!exam) return;

    const examId = getExamId(exam);
    if (!examId) {
      console.warn("Invalid exam object", exam);
      return;
    }

    const examset = {
      id: examId,
      label: exam.label,
      value: examId,
    };

    if (isExam) {
      const exists = examOptions.some((ex) => ex.label === exam.label);

      if (exists) {
        // ✅ SAFE DELETE
        await deleteUserExam({
          exams: [examId],
          subexams: [],
        });

        setExamOptions((prev) => prev.filter((ex) => ex.label !== exam.label));
      } else {
        setExamOptions((prev) => [...prev, examset]);
        await handleSaveExam(examset);
      }
    } else {
      const exists = subExamOptions.some(
        (ex) => (ex.id || ex.value) === examId,
      );

      if (exists) {
        // ✅ SAFE DELETE
        await deleteUserExam({
          exams: [],
          subexams: [examId],
        });

        setSubExamOptions((prev) =>
          prev.filter((ex) => (ex.id || ex.value) !== examId),
        );
      } else {
        if (!activeExam?.code) {
          SafeToast.error("Select an exam first");
          return;
        }
        setSubExamOptions((prev) => [
          ...prev,
          {
            ...exam,
            parentCode: activeExam.code,
          },
        ]);
        await handleSaveExam(examset);
      }
    }
  };

  const handleSaveExam = async (exam) => {
    try {
      const payload = {
        [isExam ? "exams" : "subexams"]: [exam.id],
      };
      const res = await putWithTokenAPI(
        token,
        `${user_exams_add}/${userId}/exams-add`,
        payload,
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Profile updated successfully");

        dispatch(
          setProfileData({
            name:
              roleType === "superadmin"
                ? res.data.name
                : res.data.nameofInstitution,
            phone: res.data.phoneNumber,
            role: res.data.roleType,
            price: res.data.adminPrice,
            profileImage: res.data.profile_img,
            logo: res.data.logo,
          }),
        );
        fetchUserExams();
      } else {
        SafeToast.error(res?.message || "Update failed");
      }
    } catch (error) {
      console.error("Update error:", error);
      SafeToast.error("Something went wrong");
    }
  };

  const handleOpenDialog = (name) => {
    console.log(name, "handleOpenDialog");
    setExamName(name);
    setOpenDialog(true);
  };




  const [omrModalOpen, setOmrModalOpen] = useState(false);

  const handleSelectOMR = async (templateName, templateSrc) => {
    setLoading(true);
    try {
      const response = await fetch(templateSrc);
      const blob = await response.blob();
      const file = new File([blob], `${templateName.toLowerCase().replace(/ /g, "_")}.png`, { type: "image/png" });
      const fileUrl = await uploadFile("omrsheet", file);
      if (fileUrl) {
        setTests((prev) => {
          const updated = [...prev];
          if (updated[currentTestIndex]) {
            updated[currentTestIndex].omrsheet = {
              name: `${templateName}.png`,
              url: fileUrl,
              localSrc: templateSrc,
            };
          }
          return updated;
        });

        // Keep it in formData too, just in case other things use it
        setFormData((prev) => ({
          ...prev,
          omrsheet: {
            name: `${templateName}.png`,
            url: fileUrl,
            localSrc: templateSrc,
          },
        }));

        SafeToast.success(`${templateName} template selected and uploaded!`);
      }
    } catch (error) {
      console.error("Error uploading OMR template:", error);
      SafeToast.error("Failed to upload OMR template");
    } finally {
      setLoading(false);
      setOmrModalOpen(false);
    }
  };

  const getLocalOMRTemplate = (name) => {
    if (!name) return null;
    const cleanName = name.toLowerCase();
    if (cleanName.includes("20 ")) return OMR_20;
    if (cleanName.includes("50 ")) return OMR_50;
    if (cleanName.includes("100 ")) return OMR_100;
    if (cleanName.includes("150 ")) return OMR_150;
    if (cleanName.includes("200 ")) return OMR_200;
    return null;
  };

  const handleOMRDownload = async () => {
    const currentOmr = tests[currentTestIndex]?.omrsheet;
    if (currentOmr) {
      const localAsset = getLocalOMRTemplate(currentOmr.name) || currentOmr.localSrc;
      const downloadUrl = localAsset || currentOmr.url;

      if (!downloadUrl) return;

      // Open in a new tab for viewing
      window.open(downloadUrl, "_blank");
    }
  };
  const [omrDialogOpen, setOmrDialogOpen] = useState(false);
  const [omrPage, setOmrPage] = useState(1);

  const handleOpenOMRDialog = () => {
    const currentTest = tests[currentTestIndex];
    if (!currentTest) return;

    setOmrPage(1);

    if (
      currentTest.answers &&
      currentTest.answers.length > 0
    ) {
      const formattedAnswers = {};
      currentTest.answers.forEach((ans) => {
        if (ans.questionNumber && ans.correctAnswer) {
          formattedAnswers[ans.questionNumber] = ans.correctAnswer;
        }
      });
      setAnswers(formattedAnswers);
      localStorage.setItem("omrAnswers", JSON.stringify(formattedAnswers));
    }

    setOmrDialogOpen(true);
  };


  const [numberOfTesting, setNumberOfTesting] = useState(() => {
    const saved = localStorage.getItem("numberOfTesting");
    return saved ? parseInt(saved) : 1;
  });

  const [currentTestIndex, setCurrentTestIndex] = useState(() => {
    const saved = localStorage.getItem("currentTestIndex");
    return saved ? parseInt(saved) : 0;
  });

  const [tests, setTests] = useState(() => {
    try {
      const saved = localStorage.getItem("testBatches");
      if (saved) return JSON.parse(saved);
    } catch (e) { }
    return [
      {
        testNo: "",
        totalQuestions: "",
        questionPdf: null,
        omrsheet: null,
        videoLink: "",
      },
    ];
  });

  // Persist tests to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("testBatches", JSON.stringify(tests));
  }, [tests]);

  useEffect(() => {
    localStorage.setItem("numberOfTesting", numberOfTesting);
  }, [numberOfTesting]);

  useEffect(() => {
    localStorage.setItem("currentTestIndex", currentTestIndex);
  }, [currentTestIndex]);

  // Effect to sync answers when switching tests or loading test data
  useEffect(() => {
    const currentTest = tests[currentTestIndex];
    if (!currentTest || !currentTest.testNo) return;

    const allAnswers = JSON.parse(localStorage.getItem("allOmrAnswers") || "{}");

    // Case 1: We switched tests!
    if (prevTestNoRef.current && prevTestNoRef.current !== currentTest.testNo) {
      // Now load the new test's answers
      let testAnswers = allAnswers[currentTest.testNo];
      if (!testAnswers || Object.keys(testAnswers).length === 0) {
        if (currentTest.answers && currentTest.answers.length > 0) {
          const formattedAnswers = {};
          currentTest.answers.forEach((ans) => {
            if (ans.questionNumber && ans.correctAnswer) {
              formattedAnswers[ans.questionNumber] = ans.correctAnswer;
            }
          });
          testAnswers = formattedAnswers;
          allAnswers[currentTest.testNo] = testAnswers;
          localStorage.setItem("allOmrAnswers", JSON.stringify(allAnswers));
        } else {
          testAnswers = {};
        }
      }

      setAnswers(testAnswers);
      localStorage.setItem("omrAnswers", JSON.stringify(testAnswers));
      prevTestNoRef.current = currentTest.testNo;
      return;
    }

    // Case 2: First load or data came from server — only set if answers state is empty
    if (!answers || Object.keys(answers).length === 0) {
      let testAnswers = allAnswers[currentTest.testNo];
      if (!testAnswers || Object.keys(testAnswers).length === 0) {
        if (currentTest.answers && currentTest.answers.length > 0) {
          const formattedAnswers = {};
          currentTest.answers.forEach((ans) => {
            if (ans.questionNumber && ans.correctAnswer) {
              formattedAnswers[ans.questionNumber] = ans.correctAnswer;
            }
          });
          testAnswers = formattedAnswers;
          allAnswers[currentTest.testNo] = testAnswers;
          localStorage.setItem("allOmrAnswers", JSON.stringify(allAnswers));
        }
      }
      if (testAnswers && Object.keys(testAnswers).length > 0) {
        setAnswers(testAnswers);
        localStorage.setItem("omrAnswers", JSON.stringify(testAnswers));
      }
    }

    prevTestNoRef.current = currentTest.testNo;
  }, [currentTestIndex, tests]);

  // Separate effect to save answers to localStorage whenever they change
  useEffect(() => {
    const currentTest = tests[currentTestIndex];
    if (!currentTest || !currentTest.testNo) return;
    if (!answers || Object.keys(answers).length === 0) return;

    const allAnswers = JSON.parse(localStorage.getItem("allOmrAnswers") || "{}");
    allAnswers[currentTest.testNo] = answers;
    localStorage.setItem("allOmrAnswers", JSON.stringify(allAnswers));
    localStorage.setItem("omrAnswers", JSON.stringify(answers));
  }, [answers]);

  const handleBatchSelect = async (selected) => {

    if (selected.value === "add_new") {
      setShowBatchInput(true);

      setFormData((prev) => ({
        ...prev,
        testBatchName: "",
      }));

      // Clear answers and reset test list
      setAnswers({});
      localStorage.removeItem("omrAnswers");
      localStorage.removeItem("allOmrAnswers");
      localStorage.removeItem("testBatches");
      setTests([
        {
          testNo: "",
          totalQuestions: "",
          questionPdf: null,
          omrsheet: null,
          videoLink: "",
        },
      ]);
      setNumberOfTesting(1);
      setCurrentTestIndex(0);
      prevTestNoRef.current = "";

      return;
    }

    setShowBatchInput(false);

    try {

      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}&examType=${activeExam.value}&testBatchName=${selected.value}`
      );

      if (response?.statusCode === 200) {

        // ✅ FIXED
        const batches = response?.data?.data || [];

        // ✅ SAFETY CHECK
        if (!batches.length) {
          SafeToast.error("No batch found");
          return;
        }

        const latestPublishedBatch = batches
          .filter((item) => item.isPublished && item.totalQuestions)
          .sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          )[0];

        const calculatedLastUpdatedQuestions = latestPublishedBatch?.totalQuestions || 0;
        setLastUpdatedQuestions(calculatedLastUpdatedQuestions);

        // Clear old cached answers and reset answers state when switching batches
        localStorage.removeItem("allOmrAnswers");
        localStorage.removeItem("omrAnswers");
        setAnswers({});
        prevTestNoRef.current = "";

        const first = batches[0];

        setFormData((prev) => ({
          ...prev,
          testBatchName: first?.testBatchName || "",
          headlineTagline: first?.headlineTagline || "",
          bannerTagline: first?.bannerTagline || "",
          testFees: first?.testFees || "",
          syllabus: first?.syllabus || "",
          subTopic: first?.subTopic || "",
          schedulePdf: first?.schedulePdf
            ? {
              name: "Schedule PDF",
              url: first.schedulePdf,
            }
            : null,
        }));


        // ✅ REMOVE DUPLICATES USING testNo
        const uniqueTests = [
          ...new Map(
            batches.map((item) => [
              item.testNo,
              item
            ])
          ).values()
        ];

        // ✅ SORT ASCENDING
        uniqueTests.sort((a, b) => a.testNo - b.testNo);

        // ✅ TESTS WITH FULL MAPPING
        const mappedTests = uniqueTests.map((item) => ({
          _id: item?._id || "",

          testNo: item?.testNo || "",

          totalQuestions: (item?.totalQuestions && parseInt(item.totalQuestions) > 0)
            ? item.totalQuestions
            : (calculatedLastUpdatedQuestions || ""),

          questionPdf: item?.questionFiles?.questionPdf
            ? {
              name: "Question PDF",
              url: item.questionFiles.questionPdf,
            }
            : null,

          omrsheet: item?.questionFiles?.omrsheet
            ? {
              name: "OMR Sheet",
              url: item.questionFiles.omrsheet,
            }
            : null,

          videoLink: item?.questionFiles?.videoLink || "",

          answers: item?.questionFiles?.answers || [],

          isPublished: item?.isPublished || false,
        }));

        setTests(mappedTests);

        setNumberOfTesting(mappedTests.length);

        setCurrentTestIndex(0);

        SafeToast.success("Batch loaded successfully");
      }

    } catch (error) {
      console.log(error);
      SafeToast.error("Failed to load batch");
    }
  };
  return (
    <div className="upload-page">
      <div className="exam-box" style={{ padding: "24px", background: "#fff", borderRadius: "12px", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)" }}>
        {/* Header Section */}
        <div className="exam-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h4 style={{ margin: 0, fontSize: "1.25rem", fontWeight: "600", color: "#1e293b" }}>Exams</h4>
          <div className="nav-arrows" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div className="add-btn-wrapper">
              <button className="add-btn" onClick={() => handleOpenDialog("exam")}>
                <span className="plus">+</span>
                <span className="text">Add</span>
              </button>
            </div>
            <button className="nav-btn" onClick={ExamscrollLeft}>
              <ChevronLeft size={18} />
            </button>
            <button className="nav-btn" onClick={ExamscrollRight}>
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        {/* Tabs Section */}
        <div className="exam-tabs" style={{ marginBottom: "24px", borderBottom: "1px solid #e2e8f0", paddingBottom: "10px" }} ref={ExamtabsRef}>
          {examOptions.length > 0 ? (
            examOptions.map((exam) => (
              <button
                key={exam.id || exam.value}
                className={activeExam?.value === exam.value ? "active" : ""}
                onClick={() => handleExamClick(exam)}
              >
                {exam.label}
              </button>
            ))
          ) : (
            <div className="no-data-upload" style={{ textAlign: "center", padding: "20px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="no-data-upload-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: "40px", opacity: 0.5 }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z" />
              </svg>
              <p style={{ color: "#64748b", fontSize: "14px" }}>No exams found</p>
            </div>
          )}
        </div>

        {/* Form Fields Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", marginBottom: "24px" }}>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#475569",
              }}
            >
              Test Batch Name :
            </label>

            {showBatchInput ? (

              // INPUT FIELD
              <input
                name="testBatchName"
                value={formData.testBatchName}
                onChange={handleInputChange}
                placeholder="Enter Batch Name"
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "1px solid #cbd5e1",
                  borderRadius: "8px",
                  fontSize: "14px",
                }}
              />

            ) : (

              // DROPDOWN
              <Select
                options={[
                  {
                    label: "+ Add New Batch",
                    value: "add_new",
                  },
                  ...batchOptions,
                ]}
                placeholder="Select Batch"
                value={
                  formData.testBatchName
                    ? {
                      label: formData.testBatchName,
                      value: formData.testBatchName,
                    }
                    : null
                }
                onChange={handleBatchSelect}
              />

            )}

            {errors.testBatchName && (
              <p
                style={{
                  color: "#ef4444",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {errors.testBatchName}
              </p>
            )}
          </div>
          {/* Test Fees */}
          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#475569" }}>Test Fees :</label>
            <input
              type="number"
              name="testFees"
              value={formData.testFees}
              onChange={handleInputChange}
              style={{ width: "100%", padding: "12px", border: "1px solid #cbd5e1", borderRadius: "8px", fontSize: "14px" }}
              placeholder="Enter Fee"
            />
            {errors.testFees && <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.testFees}</p>}
          </div>

          {/* Number of Testing */}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#475569",
              }}
            >
              Number of Tests :
            </label>

            <input
              type="number"
              name="numberOfTesting"
              value={numberOfTesting}
              onChange={(e) => setNumberOfTesting(e.target.value)}
              placeholder="Enter Number of Testing"
              style={{
                width: "100%",
                padding: "12px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                fontSize: "14px",
                background: "#f8fafc",
              }}
            />
          </div>

          {/* Schedule PDF */}
          <div className="schedule-box">
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#475569" }}>Schedule PDF :</label>
            <input
              type="file"
              accept=".pdf"
              onChange={(e) => handleFileUpload("schedulePdf", e.target.files[0])}
              style={{ display: "none" }}
              id="schedulePdf"
            />
            <label htmlFor="schedulePdf" className={formData.schedulePdf ? "uploaded-btn-small" : "upload-btn-small"}
              style={{
                cursor: "pointer",
                display: "inline-block",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "1px dashed #cbd5e1",
                textAlign: "center",
                width: formData.schedulePdf ? "40%" : "80%",
              }}>
              {formData.schedulePdf ? "PDF Selected" : "Click to Upload PDF"}
            </label>

            {formData.schedulePdf && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "8px", padding: "8px", background: "#f1f5f9", borderRadius: "6px" }}>
                <a href={formData.schedulePdf.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#2563eb", fontSize: "13px", display: "flex", alignItems: "center", gap: "5px" }}>
                  📄 {formData.schedulePdf.name}
                </a>
                <button onClick={() => handleRemovePdf("schedulePdf")} style={{ border: "none", background: "transparent", cursor: "pointer", color: "#ef4444" }}>
                  <IoClose size={18} />
                </button>
              </div>
            )}
            {errors.schedulePdf && <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.schedulePdf}</p>}
          </div>
        </div>

        {/* Submit Button Section */}
        <div
          style={{
            borderTop: "1px solid #e2e8f0",
            paddingTop: "20px",
            textAlign: "right",
          }}
        >
          <button
            className="publish-btn"
            onClick={handleCreateExamBatch}
            style={{
              minWidth: "180px",
              padding: "12px 24px",
            }}
          >
            Create Exam Batch
          </button>
        </div>
      </div>

      {formData.testBatchName && tests.length > 0 && tests[0]?.testNo !== "" && (
        <div className="main-card">
          <div className="card-body">

            {/* Pagination Tabs */}
            {/* <div
              style={{
                display: "flex",
                gap: "10px",
                marginBottom: "25px",
                flexWrap: "wrap",
              }}
            >
              {tests.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestIndex(index)}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "8px",

                    border:
                      tests[index]?.isPublished
                        ? "1px solid green"
                        : currentTestIndex === index
                          ? "1px solid #2563eb"
                          : "1px solid #cbd5e1",

                    background:
                      tests[index]?.isPublished
                        ? "green"
                        : currentTestIndex === index
                          ? "#2563eb"
                          : "#fff",

                    color:
                      tests[index]?.isPublished
                        ? "#fff"
                        : currentTestIndex === index
                          ? "#fff"
                          : "#475569",

                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Test {index + 1}
                </button>
              ))}
            </div> */}

            <div
              style={{
                display: "flex",
                gap: "10px",
                marginBottom: "25px",
                flexWrap: "wrap",
              }}
            >
              {tests.map((_, index) => {
                const isPublished = tests[index]?.isPublished;
                const isActive = currentTestIndex === index;

                return (
                  <button
                    key={index}
                    onClick={() => setCurrentTestIndex(index)}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "10px",
                      border: isPublished
                        ? "2px solid #16a34a"
                        : isActive
                          ? "2px solid #2563eb"
                          : "1px solid #cbd5e1",

                      background: isPublished ? "#16a34a" : "#fff",

                      color: isPublished ? "#fff" : isActive ? "#2563eb" : "#475569",

                      cursor: "pointer",
                      fontWeight: "600",

                      // Active highlight
                      transform: isActive ? "translateY(-2px)" : "translateY(0)",
                      boxShadow: isActive
                        ? "0 0 0 4px rgba(37, 99, 235, 0.2)"
                        : "none",

                      transition: "all 0.2s ease",
                    }}
                  >
                    {isPublished ? "✓ " : ""}
                    Test {index + 1}
                  </button>
                );
              })}
            </div>

            {/* Questions Content */}
            <div className="questions-content">

              {/* Top Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1.2fr",
                  gap: "24px",
                  alignItems: "end",
                }}
              >

                {/* Test No */}
                {/* <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    Test No :
                  </label>

                  <div className="confirm-box">
                    <input
                      type="text"
                      value={tests[currentTestIndex]?.testNo}
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "8px",
                      }}
                      disabled={true}
                      onChange={(e) => {
                        const updated = [...tests];
                        updated[currentTestIndex].testNo =
                          e.target.value;
                        setTests(updated);
                      }}
                    />
                  </div>
                </div> */}

                {/* Total Questions */}
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    Total Questions :
                  </label>

                  <div className="confirm-box">
                    <input
                      type="number"
                      placeholder={
                        lastUpdatedQuestions
                          ? `Enter total questions (Default: ${lastUpdatedQuestions})`
                          : "Enter total questions"
                      }
                      value={
                        tests[currentTestIndex]?.totalQuestions || ""
                      }
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "8px",
                      }}
                      onChange={(e) => {
                        const updated = [...tests];
                        updated[
                          currentTestIndex
                        ].totalQuestions = e.target.value;
                        setTests(updated);
                      }}
                    />
                  </div>
                </div>

                {/* Question PDF */}
                <div>
                  <span
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      fontSize: "13px",
                    }}
                  >
                    Question PDF :
                  </span>

                  <div
                    className="upload-card"
                    style={{
                      width: "100%",
                      height: "46px",
                      marginTop: "0",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0 16px",
                      border: tests[currentTestIndex]?.questionPdf
                        ? "1px solid #22c55e"
                        : "1px solid #cbd5e1",
                      borderRadius: "8px",
                      background: tests[currentTestIndex]?.questionPdf
                        ? "#f0fdf4"
                        : "#fff",
                      transition: "0.3s",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        color: tests[currentTestIndex]?.questionPdf
                          ? "#16a34a"
                          : "#64748b",
                        fontWeight: "500",
                      }}
                    >
                      {tests[currentTestIndex]?.questionPdf
                        ? "PDF uploaded "
                        : "PDF document"}
                    </span>

                    {tests[currentTestIndex]?.questionPdf ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {/* VIEW BUTTON */}
                        <div
                          onClick={() => {
                            const file = tests[currentTestIndex]?.questionPdf;
                            if (file) {
                              if (file.url) {
                                window.open(file.url, "_blank");
                              } else {
                                const blobUrl = URL.createObjectURL(file);
                                window.open(blobUrl, "_blank");
                              }
                            }
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            background: "#22c55e",
                            color: "#fff",
                            padding: "7px 14px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "600",
                          }}
                        >
                          <Upload size={14} />
                          Uploaded
                        </div>

                        {/* REMOVE BUTTON */}
                        <button
                          onClick={() => {
                            const updated = [...tests];
                            updated[currentTestIndex].questionPdf = null;
                            setTests(updated);
                          }}
                          style={{
                            border: "none",
                            background: "#fee2e2",
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#dc2626",
                          }}
                        >
                          <IoClose />
                        </button>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          accept=".pdf"
                          style={{ display: "none" }}
                          id={`questionPdf-${currentTestIndex}`}
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              const updated = [...tests];
                              updated[currentTestIndex].questionPdf =
                                e.target.files[0];
                              setTests(updated);
                            }
                          }}
                        />
                        <label
                          htmlFor={`questionPdf-${currentTestIndex}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            background: "#2563eb",
                            color: "#fff",
                            padding: "7px 14px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          <Upload size={14} />
                          Upload
                        </label>
                      </>
                    )}
                  </div>
                </div>


                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    Video Link :
                  </label>

                  <input
                    type="text"
                    value={
                      tests[currentTestIndex]?.videoLink
                    }
                    onChange={(e) => {
                      const updated = [...tests];
                      updated[currentTestIndex].videoLink =
                        e.target.value;
                      setTests(updated);
                    }}
                    className="video-url-input"
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: "8px",
                    }}
                    placeholder="Enter video link"
                  />
                </div>

                {tests[currentTestIndex]?.totalQuestions > 0 && (
                  <div >
                    <span
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontWeight: "500",
                        fontSize: "13px",
                      }}
                    >
                      Answer Upload :
                    </span>

                    <div
                      className="answer-card-container"
                      onClick={handleOpenOMRDialog}
                      style={{
                        cursor: "pointer",
                        maxWidth: "320px",
                      }}
                    >
                      <div
                        className="answer-card"
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                        }}
                      >
                        <button
                          style={{
                            border: "none",
                            background: "none",
                            color: "#1e293b",
                            fontWeight: "600",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          Answers
                        </button>

                        <div
                          className="eye-icon"
                          style={{ color: "#64748b" }}
                        >
                          <Eye size={18} />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>

              {/* Second Grid */}
              <div className="questions-content">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "24px",
                    alignItems: "start",
                    marginTop: "15px",
                  }}
                >


                  {/* <div>
  <span
    style={{
      display: "block",
      marginBottom: "8px",
      fontWeight: "500",
      fontSize:"13px",
    }}
  >
    OMR Sheet Template
  </span>

  <div
    className="upload-card"
    style={{
      width: "100%",
      height: "46px",
      marginTop: "0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 16px",
      border: tests[currentTestIndex]?.omrsheet
        ? "1px solid #22c55e"
        : "1px solid #cbd5e1",
      borderRadius: "8px",
      background: tests[currentTestIndex]?.omrsheet
        ? "#f0fdf4"
        : "#fff",
      transition: "0.3s",
    }}
  >
    <span
      style={{
        fontSize: "14px",
        color: tests[currentTestIndex]?.omrsheet
          ? "#16a34a"
          : "#64748b",
        fontWeight: "500",
      }}
    >
      {tests[currentTestIndex]?.omrsheet
        ? "OMR Uploaded Successfully"
        : "OMR Sheet Document"}
    </span>

    {tests[currentTestIndex]?.omrsheet ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div
          onClick={handleOMRDownload}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            background: "#22c55e",
            color: "#fff",
            padding: "7px 14px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          <Download size={14} />
          Uploaded
        </div>
        <button
          onClick={() => {
            const updated = [...tests];
            updated[currentTestIndex].omrsheet = null;
            setTests(updated);
          }}
          style={{
            border: "none",
            background: "#fee2e2",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#dc2626",
          }}
        >
          <IoClose />
        </button>
      </div>
    ) : (
      <div
        onClick={() => setOmrModalOpen(true)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          background: "#2563eb",
          color: "#fff",
          padding: "7px 14px",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: "600",
        }}
      >
        <Upload size={14} />
        Upload
      </div>
    )}
  </div>
</div> */}

                  {/* Video Link */}

                </div>


                {/* Bottom Buttons */}
                <div
                  className="publish-row"
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >

                  {/* PREVIOUS */}
                  <button
                    className="next-btn-upload"
                    style={{
                      background: "#cbd5e1",
                      color: "#475569",
                    }}
                    disabled={currentTestIndex === 0}
                    onClick={() =>
                      setCurrentTestIndex((prev) => prev - 1)
                    }
                  >
                    <ChevronLeft size={18} />
                    Previous
                  </button>

                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                    }}
                  >

                    {/* NEXT */}
                    {currentTestIndex !== tests.length - 1 && (
                      <button
                        className="next-btn-upload"
                        onClick={() =>
                          setCurrentTestIndex((prev) => prev + 1)
                        }
                      >
                        Next
                        <ChevronRight size={18} />
                      </button>
                    )}

                    {/* PUBLISH */}
                    {/* {!tests[currentTestIndex]?.isPublished && ( */}
                    <button
                      className="publish-btn"
                      disabled={loading}
                      onClick={handlePublish}
                    >
                      {tests[currentTestIndex]?.isPublished ? loading ? "Updating..." : "Update" : loading ? "Publishing..." : "Publish"}
                      {/* {loading ? "Publishing..." : "Publish"} */}
                    </button>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {openDialog && (
        <div className="modal-overlay">
          <div className="crop-modal">
            <div className="modal-header">
              <h3> {isExam ? "Add New Exam" : "Add Sub New Exam"}</h3>
              <button
                className="close-modal"
                onClick={() => {
                  setShowAddInput(false);
                  setOpenDialog(false);
                }}
              >
                <FiX />
              </button>
            </div>
            <div className="modal-body-exam">
              {showAddInput && (
                <div className="input-box single">
                  <input
                    type="text"
                    value={newExamValue}
                    onChange={(e) => setNewExamValue(e.target.value)}
                    placeholder="Enter new exam"
                  />

                  <div className="add-btn-wrapper">
                    <button className="add-btn" onClick={() => handleAddExam()}>
                      <span className="plus">+</span>
                      <span className="text">Create</span>
                    </button>
                  </div>
                </div>
              )}
              <div
                className="exam-checkbox-list"
                style={{
                  display: isExam
                    ? allexamOptions.length > 0
                      ? "grid"
                      : "block"
                    : filteredSubExams.length > 0
                      ? "grid"
                      : "block",
                }}
              >
                {isExam ? (
                  allexamOptions.length > 0 ? (
                    allexamOptions.map((exam) => (
                      <label
                        key={exam.id || exam.value}
                        className="exam-checkbox-item"
                      >
                        <input
                          type="checkbox"
                          checked={isExamChecked(exam)}
                          onChange={() => handleAddExamClick(exam)}
                        />
                        <span className="check-label">{exam.label}</span>
                      </label>
                    ))
                  ) : (
                    <div className="no-data-upload">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="no-data-upload-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                        />
                      </svg>
                      <span>No exams found</span>
                    </div>
                  )
                ) : filteredSubExams.length > 0 ? (
                  filteredSubExams.map((exam) => {
                    const checked = isExamChecked(exam);
                    return (
                      <label
                        key={exam.id || exam.value}
                        className={`exam-checkbox-item ${checked ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddExamClick(exam);
                        }}
                      >
                        <span className="check-label">{exam.label}</span>
                        {checked && <span className="close-icon">✕</span>}
                      </label>
                    );
                  })
                ) : (
                  <div className="no-data-upload" style={{ width: "90%" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="no-data-upload-icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                      />
                    </svg>
                    <span>No exams found</span>
                  </div>
                )}

                {!showAddInput && (
                  <div
                    className="exam-checkbox-item add-exam"
                    onClick={() => setShowAddInput(true)}
                  >
                    <span className="plus-icon">+</span>
                    <span className="check-label">Create</span>
                  </div>
                )}
              </div>
            </div>
            {/* {isExam && ( */}
            <div className="crop-actions">
              <button
                className="cancel-crop-btn"
                onClick={() => {
                  setShowAddInput(false);
                  setOpenDialog(false);
                }}
              >
                Cancel
              </button>
              <button
                className="apply-crop-btn"
                onClick={() => handleAddExam()}
              >
                Save
              </button>
            </div>
            {/* )} */}
          </div>
        </div>
      )}

      {omrModalOpen && (
        <div className="modal-overlay">
          <div className="crop-modal" style={{ maxWidth: "600px" }}>
            <div className="modal-header">
              <h3>Select OMR Sheet Template</h3>
              <button
                className="close-modal"
                onClick={() => setOmrModalOpen(false)}
              >
                <FiX />
              </button>
            </div>
            <div className="modal-body-exam" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", padding: "10px" }}>
                {[
                  { name: "OMR 20 Questions", src: OMR_20, questions: 20 },
                  { name: "OMR 50 Questions", src: OMR_50, questions: 50 },
                  { name: "OMR 100 Questions", src: OMR_100, questions: 100 },
                  { name: "OMR 150 Questions", src: OMR_150, questions: 150 },
                  { name: "OMR 200 Questions", src: OMR_200, questions: 200 }
                ].map((template) => (
                  <div
                    key={template.name}
                    className="omr-template-card"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "10px",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      background: "#fdfdfd"
                    }}
                    onClick={() => handleSelectOMR(template.name, template.src)}
                  >
                    <div style={{ height: "120px", overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #eee", borderRadius: "4px", marginBottom: "10px", background: "#fff" }}>
                      <img src={template.src} alt={template.name} style={{ height: "100%", objectFit: "contain" }} />
                    </div>
                    <span style={{ fontWeight: "600", fontSize: "14px" }}>{template.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      )}

      {omrDialogOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(15, 23, 42, 0.4)",
            backdropFilter: "blur(8px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              width: "90%",
              maxWidth: "1440px",
              maxHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
              border: "1px solid rgba(226, 232, 240, 0.8)",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 24px",
                borderBottom: "1px solid #f1f5f9",
                background: "#f8fafc",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.25rem",
                    fontWeight: "700",
                    color: "#0f172a",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  Configure Answer Key - Test {tests[currentTestIndex]?.testNo}
                  {tests[currentTestIndex]?.isPublished && (
                    <span
                      style={{
                        background: "#dcfce7",
                        color: "#15803d",
                        fontSize: "11px",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Published
                    </span>
                  )}
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#64748b" }}>
                  Total Questions: {tests[currentTestIndex]?.totalQuestions}
                </p>
              </div>
              <button
                onClick={() => setOmrDialogOpen(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  color: "#94a3b8",
                  padding: "6px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.2s, color 0.2s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f1f5f9";
                  e.currentTarget.style.color = "#475569";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = "#94a3b8";
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Pagination Controls */}
            {(() => {
              const totalQ = parseInt(tests[currentTestIndex]?.totalQuestions) || 0;
              const totalPages = Math.ceil(totalQ / 40);
              if (totalPages <= 1) return null;

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    padding: "16px 24px 8px 24px",
                    borderBottom: "1px solid #f1f5f9",
                    background: "#ffffff",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <button
                    onClick={() => setOmrPage(prev => Math.max(prev - 1, 1))}
                    disabled={omrPage === 1}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                      background: omrPage === 1 ? "#f8fafc" : "#fff",
                      color: omrPage === 1 ? "#94a3b8" : "#475569",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: omrPage === 1 ? "not-allowed" : "pointer",
                      transition: "all 0.2s",
                    }}
                  >
                    Previous
                  </button>

                  {Array.from({ length: totalPages }).map((_, idx) => {
                    const pageNum = idx + 1;
                    const pageStart = (pageNum - 1) * 40 + 1;
                    const pageEnd = Math.min(pageNum * 40, totalQ);
                    const isActive = omrPage === pageNum;

                    return (
                      <button
                        key={pageNum}
                        onClick={() => setOmrPage(pageNum)}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "8px",
                          border: isActive ? "none" : "1px solid #e2e8f0",
                          background: isActive ? "#2563eb" : "#f8fafc",
                          color: isActive ? "#fff" : "#475569",
                          fontWeight: "600",
                          fontSize: "13px",
                          cursor: "pointer",
                          boxShadow: isActive ? "0 4px 6px -1px rgba(37, 99, 235, 0.2)" : "none",
                          transition: "all 0.2s",
                          minWidth: "100px",
                        }}
                      >
                        {pageStart} - {pageEnd}
                      </button>
                    );
                  })}

                  <button
                    onClick={() => setOmrPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={omrPage === totalPages}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                      background: omrPage === totalPages ? "#f8fafc" : "#fff",
                      color: omrPage === totalPages ? "#94a3b8" : "#475569",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: omrPage === totalPages ? "not-allowed" : "pointer",
                      transition: "all 0.2s",
                    }}
                  >
                    Next
                  </button>
                </div>
              );
            })()}

            {/* Modal Body */}
            <div
              style={{
                flex: 1,
                padding: "24px",
                overflowY: "auto",
                background: "#ffffff",
              }}
            >
              {(() => {
                const totalQ = parseInt(tests[currentTestIndex]?.totalQuestions) || 0;
                const startQ = (omrPage - 1) * 40 + 1;
                const endQ = Math.min(omrPage * 40, totalQ);

                const columns = [];
                for (let c = 0; c < 4; c++) {
                  const colStart = startQ + c * 10;
                  if (colStart <= endQ) {
                    const colQuestions = [];
                    const colEnd = Math.min(colStart + 9, endQ);
                    for (let q = colStart; q <= colEnd; q++) {
                      colQuestions.push(q);
                    }
                    columns.push(colQuestions);
                  }
                }

                const renderQuestionItem = (qNo) => {
                  const selectedOpt = answers[qNo];
                  return (
                    <div
                      key={qNo}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px 14px",
                        borderRadius: "10px",
                        background: selectedOpt ? "#f0f7ff" : "#f8fafc",
                        border: selectedOpt
                          ? "1px solid #bfdbfe"
                          : "1px solid #e2e8f0",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: selectedOpt ? "#1d4ed8" : "#475569",
                          minWidth: "28px",
                        }}
                      >
                        {qNo}.
                      </span>
                      <div style={{ display: "flex", gap: "6px" }}>
                        {["A", "B", "C", "D"].map((opt) => {
                          const isFilled = selectedOpt === opt;
                          return (
                            <button
                              key={opt}
                              onClick={() => {
                                setAnswers((prev) => {
                                  const updated = { ...prev, [qNo]: opt };
                                  return updated;
                                });
                              }}
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "50%",
                                border: isFilled
                                  ? "1px solid #2563eb"
                                  : "1px solid #cbd5e1",
                                background: isFilled ? "#2563eb" : "#fff",
                                color: isFilled ? "#fff" : "#64748b",
                                fontSize: "11px",
                                fontWeight: "700",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: tests[currentTestIndex]?.isPublished
                                  ? "pointer"
                                  : "pointer",
                                transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                                outline: "none",
                              }}
                              onMouseOver={(e) => {
                                if (!isFilled) {
                                  e.currentTarget.style.borderColor = "#2563eb";
                                  e.currentTarget.style.color = "#2563eb";
                                  e.currentTarget.style.background = "#eff6ff";
                                }
                              }}
                              onMouseOut={(e) => {
                                if (!isFilled) {
                                  e.currentTarget.style.borderColor = "#cbd5e1";
                                  e.currentTarget.style.color = "#64748b";
                                  e.currentTarget.style.background = "#fff";
                                }
                              }}
                            >
                              {opt}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                };

                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "24px",
                      flexWrap: "wrap",
                      padding: "20px 0",
                    }}
                  >
                    {columns.map((colQs, colIdx) => (
                      <div
                        key={colIdx}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          width: "100%",
                          maxWidth: "280px",
                        }}
                      >
                        {colQs.map(qNo => renderQuestionItem(qNo))}
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>

            {/* Modal Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 24px",
                borderTop: "1px solid #f1f5f9",
                background: "#f8fafc",
              }}
            >
              <div>
                <button
                  onClick={() => {
                    setAnswers({});
                    localStorage.setItem("omrAnswers", JSON.stringify({}));
                  }}
                  style={{
                    border: "1px solid #ef4444",
                    background: "transparent",
                    color: "#ef4444",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#fef2f2";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  Clear All
                </button>
              </div>
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  onClick={() => setOmrDialogOpen(false)}
                  style={{
                    border: "1px solid #cbd5e1",
                    background: "#fff",
                    color: "#475569",
                    padding: "8px 20px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#f8fafc";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  {tests[currentTestIndex]?.isPublished ? "Close" : "Cancel"}
                </button>
                <button
                  onClick={async () => {
                    localStorage.setItem("omrAnswers", JSON.stringify(answers));

                    const currentTest = tests[currentTestIndex];
                    if (currentTest?.isPublished) {
                      setLoading(true);
                      try {
                        const answersArray = Object.entries(answers)
                          .filter(([_, value]) => value)
                          .map(([questionNumber, correctAnswer]) => ({
                            questionNumber: parseInt(questionNumber),
                            correctAnswer,
                          }));

                        const questionPdfUrl = currentTest.questionPdf?.url || "";

                        const batchData = {
                          Institution_id: Institutionprofile._id,
                          examType: activeExam.value,
                          testFees: parseInt(formData.testFees) || 0,
                          testBatchName: formData.testBatchName || "",
                          schedulePdf: formData?.schedulePdf?.url || "",
                          testNo: parseInt(currentTest.testNo),
                          totalQuestions: parseInt(currentTest.totalQuestions || lastUpdatedQuestions || 0) || 0,
                          numberofTests: numberOfTesting,
                          isPublished: true,
                          questionFiles: {
                            questionPdf: questionPdfUrl,
                            answerPdf: formData?.answerPdf?.url || "",
                            videoLink: currentTest.videoLink || "",
                            answers: answersArray,
                            omrsheet: currentTest.omrsheet?.url || "",
                          },
                        };

                        const response = await putWithTokenAPI(
                          token,
                          `/batch/update/${currentTest._id}`,
                          batchData
                        );

                        if (response?.statusCode === 200 || response?.statusCode === 201) {
                          SafeToast.success("Answers updated successfully!");
                          await fetchBatchList();
                        } else {
                          SafeToast.error("Failed to update answers on server");
                        }
                      } catch (err) {
                        console.error(err);
                        SafeToast.error("Error updating answers");
                      } finally {
                        setLoading(false);
                      }
                    } else {
                      SafeToast.success("Answers configured locally!");
                    }

                    setOmrDialogOpen(false);
                  }}
                  style={{
                    border: "none",
                    background: "#2563eb",
                    color: "#fff",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#1d4ed8";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "#2563eb";
                  }}
                >
                  Save Answers
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadPage;
